import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import './CityFarmV2.css';
import { Box } from '@mui/material';
import Modal from '@mui/material/Modal';

// Reutilizamos las funciones REALES de CITYFARM. Así V2 usa exactamente
// los mismos servicios, Redux y backend que la versión clásica.
import { Agua } from '../logica/Modales/Agua';
import { TierraMaiz } from '../logica/Modales/TierraMaiz';
import { Trigo } from '../logica/Modales/Trigo';
import { Arbol } from '../logica/Modales/Arbol';
import { Energia } from '../logica/Modales/Energia';
import { Vaca } from '../logica/Modales/Vaca';
import { Gallinero } from '../logica/Modales/Gallinero';
import { Wallet } from '../logica/Modales/Wallet';
import { Profile } from '../logica/Modales/Profile';
import { Objetos } from '../logica/Modales/Ojbetos';
import { TradesMarket } from '../logica/market/TradesMarket';
import { PacksMarket } from '../logica/market/PacksMarket';
import { Molino } from '../logica/molino/Molino';
import { Stake } from '../logica/Modales/profile/Stake';
import CityFarmVisitFarms from '../logica/CityFarmVisitFarms';
import CityFarmAgricultureV2 from './agriculture/CityFarmAgricultureV2';
import PetOverlay from '../logica/PetOverlay/PetOverlay';
import CityFarmWhitepaper from './CityFarmWhitepaper';
import CityFarmOperationHistory from './CityFarmOperationHistory';
import { rutas } from '../rutas/rutas';
import { getCookie } from '../utils/getCookies';

import grass from '../image/aaa.png';
import premiumMap from './assets/environment/cityfarm-expanded-landscape.jpg';
import trigoLand from '../image/tieraTrigo.png';
import maizLand from '../image/pasto.png';
import energiaLand from '../image/Land_Electrica.png';
import aguaLand from '../image/Land_pozo.png';
import vacasLand from '../image/Land_vacas.png';
import gallinasLand from '../image/land_gallinas.png';
import molinoLand from '../image/molino.png';
import casaLand from '../image/casa.png';
import arbol from '../image/arbol.png';
import vacaSprite from '../image/vaca.png';
import gallinaSprite from '../image/gallina.png';
import galloSprite from '../image/gallo-export.png';
import bigDogBoneLogo from './assets/bigdogbone-logo.png';
import rural01 from './assets/buildings/rural/01_oficina_tierras.png';
import rural02 from './assets/buildings/rural/02_objetos_tickets.png';
import rural03 from './assets/buildings/rural/03_almacen.png';
import rural04 from './assets/buildings/rural/04_casa_bigdogbone.png';
import rural05 from './assets/buildings/rural/05_mercado_trade.png';
import rural06 from './assets/buildings/rural/06_estacion_granjas.png';
import rural07 from './assets/buildings/rural/07_estacion_pool.png';
import rural08 from './assets/buildings/rural/08_tienda_packs.png';
import rural09 from './assets/buildings/rural/09_perfil_retiros.png';

const RURAL_FACILITY_SPRITES = {
  'land-office': rural01,
  'objects-workshop': rural02,
  'inventory-warehouse': rural03,
  'bigdogbone-house': rural04,
  'trade-exchange': rural05,
  'visit-station': rural06,
  'pool-station': rural07,
  'packs-shop': rural08,
  'profile-center': rural09,
};


const LEVEL_ART = {
  // Estas son las MISMAS imágenes por nivel que ya usa CITYFARM clásico.
  wheat: [
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767275202/tieraTrigo.cb46df694f72f63aabb4_g02e5k.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767276766/lvl2_hvk6rn_iqey5g.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767276766/lvl_3_gvzzie_d5f8vb.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767276768/lvl_4_p871g9_eyg9lt.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767276767/lvl5_lmykkk_bwynot.png',
  ],
  corn: [
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767277907/pasto.b9b7aae7a28230fccbb6_pgkcfm.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767278210/lvl2_rojyue.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767278212/lvl3_zioeyi.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767278212/lvl4_fhxhah.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767278287/lvl5_c8ifrc.png',
  ],
  tree: [
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767285920/lvl1_q4eyov.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767285923/lvl2_docxz1.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767285923/lvl3_qmm43n.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767285925/lvl4_bhqffb.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767285928/lvl5_owxm6p.png',
  ],
  mill: [
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767752471/LVL_1_hobgtm.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767752471/LVL2_crp4nw.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767752474/LVL3_r6c5dh.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767752473/LVL4_ymzyk5.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767752473/LVL5_ppgq3x.png',
  ],
  water: [
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767287128/lvl1_mgtynd.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767287129/lvl2_rchvkc.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767287131/lvl3_fzeegn.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767287129/lvl4_yvysld.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767287130/lvl5_rlqhcf.png',
  ],
  energy: [
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767324324/lvl1_fnfhze.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767324327/lvl2_yjkpyu.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767324325/lvl3_e19aro.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767324326/lvl4_rcf5ew.png',
    'https://res.cloudinary.com/dkm71aag8/image/upload/v1788703107/logos/enerigia_lv5_xmvtgx.png',
  ],
  cows: [
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767280654/lvl1_kpvrhn.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767280655/lvl2_xbatel.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767280669/lvl3_ngb7zk.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767280670/lvl4_skdphg.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767280671/lvl5_gmfkfr.png',
  ],
  chickens: [
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767279773/lvl1_fzyo2i.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767279775/lvl2_tcqkuz.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767279775/lvl3_p93byw.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767279776/lvl4_viwota.png',
    'https://res.cloudinary.com/dpwv380jp/image/upload/v1767279779/lvl5_ez5sdm.png',
  ],
};
const LEVEL_ART_ALIAS = {
  wheat2: 'wheat',
  corn2: 'corn',
  tree1: 'tree',
  tree2: 'tree',
  tree3: 'tree',
};

const PLAYER_SPRITE =
  'https://res.cloudinary.com/dpwv380jp/image/upload/v1765771143/nova_od1mii.png';

// REV21: mundo ampliado. Se mantienen TODAS las coordenadas del sector original.
const WORLD = { width: 6000, height: 4000 };
const ORIGINAL_WORLD = { width: 3600, height: 2200 };
const BIGDOG_BONE_URL = 'https://www.bigdogbonegame.com/game';
const ARRANGE_GRID_SIZE = 20;
const ARRANGE_RELEASE_ALIGN_THRESHOLD = 14;
const MAP_SHIFT = { x: 560, y: 340 };
const PLAYER_START = { x: 1800, y: 1180 };
const PLAYER_SPEED = 260;
const INTERACTION_DISTANCE = 120;
const WALK_TARGET_TOLERANCE = 16;

// FASE 7: cámara/zoom puramente visual. No modifica coordenadas del backend,
// economía ni estado persistente del juego.
const ZOOM_MIN = 0.16;
const ZOOM_MAX = 1.35;
const ZOOM_STEP = 0.10;

const WEATHER_INFO = {
  clear: { icon: '☀️', es: 'DESPEJADO', en: 'CLEAR' },
  wind: { icon: '💨', es: 'VIENTO', en: 'WIND' },
  rain: { icon: '🌧️', es: 'LLUVIA', en: 'RAIN' },
  storm: { icon: '⛈️', es: 'TORMENTA', en: 'STORM' },
};

const AUTO_WEATHER_SEQUENCE = [
  { id: 'clear-open', mode: 'clear', minutes: 12, wetStart: 0.00, wetEnd: 0.00 },
  { id: 'wind-rise', mode: 'wind', minutes: 6, wetStart: 0.00, wetEnd: 0.05 },
  { id: 'rain-start', mode: 'rain', minutes: 5, wetStart: 0.12, wetEnd: 0.66 },
  { id: 'storm-peak', mode: 'storm', minutes: 3, wetStart: 0.72, wetEnd: 1.00 },
  { id: 'rain-fade', mode: 'rain', minutes: 4, wetStart: 1.00, wetEnd: 0.88 },
  { id: 'clear-drips', mode: 'clear', minutes: 8, wetStart: 0.82, wetEnd: 0.46 },
  { id: 'wind-drying', mode: 'wind', minutes: 6, wetStart: 0.46, wetEnd: 0.14 },
  { id: 'clear-reset', mode: 'clear', minutes: 10, wetStart: 0.14, wetEnd: 0.00 },
];

const AUTO_WEATHER_TOTAL_SECONDS = AUTO_WEATHER_SEQUENCE.reduce(
  (total, step) => total + step.minutes * 60,
  0
);

const formatDurationMMSS = (seconds) => {
  const safe = Math.max(0, Math.floor(Number(seconds) || 0));
  return `${String(Math.floor(safe / 60)).padStart(2, '0')}:${String(safe % 60).padStart(2, '0')}`;
};

// FASE 8: elementos 100% decorativos.
// Nunca se usan para calcular producción, niveles, recompensas ni colisiones.
const ROAD_TRAFFIC = [
  // Circulación decorativa: cada vehículo mantiene UNA dirección y reaparece
  // fuera de cámara al terminar. Así nunca "retrocede" mirando al lado contrario.
  { id: 'tractor-a', kind: 'tractor', route: 'main-right', x: -150, y: 762, duration: 105, delay: -18 },
  { id: 'truck-a', kind: 'truck', route: 'south-left', x: 2520, y: 1091, duration: 132, delay: -71 },
];

const WORLD_NPCS = [
  { id: 'npc-a', icon: '🧑‍🌾', x: 930, y: 722, route: 'npc-horizontal', duration: 58, delay: -14 },
  { id: 'npc-b', icon: '👩‍🌾', x: 1450, y: 1090, route: 'npc-small', duration: 66, delay: -31 },
];

const PUDDLES = [
  [700, 715, 96, 26], [930, 920, 74, 22], [1390, 715, 110, 28], [1650, 945, 82, 23],
  [1170, 540, 68, 20], [1200, 1100, 100, 27], [350, 930, 78, 22], [2020, 720, 92, 24],
  [575, 1425, 118, 32], [965, 1470, 92, 24], [1765, 1418, 130, 34], [2295, 1060, 88, 24],
  [2620, 520, 122, 30], [2945, 980, 90, 22], [3080, 1528, 116, 28], [2450, 1692, 104, 26],
];

const CLOUDS = [
  // Tamaños en coordenadas del mundo: al usar FIT FARM también se reducen.
  { id: 'cloud-1', x: -260, y: 90, width: 210, duration: 168, delay: -42, opacity: .17 },
  { id: 'cloud-2', x: -520, y: 260, width: 155, duration: 196, delay: -118, opacity: .13 },
  { id: 'cloud-3', x: -760, y: 455, width: 125, duration: 224, delay: -81, opacity: .10 },
];


const BUILDINGS = [
  // Todas las tierras reales están representadas físicamente en el mapa.
  // Las tierras cultivables pueden dibujar copias VISUALES según su nivel.
  // Esas copias no crean recursos ni llamadas extra al backend.
  {
    id: 'wheat', name: 'Tierra de trigo 1', icon: '🌾', image: trigoLand,
    x: 120, y: 135, width: 220, stateKey: 'trigo', 
    collider: { x: 125, y: 255, w: 330, h: 165 },
  },
  {
    id: 'wheat2', name: 'Tierra de trigo 2', icon: '🌾', image: trigoLand,
    x: 440, y: 135, width: 220, stateKey: 'trigo2', 
    collider: { x: 445, y: 255, w: 330, h: 165 },
  },
  {
    id: 'corn', name: 'Tierra de maíz 1', icon: '🌽', image: maizLand,
    x: 120, y: 410, width: 220, stateKey: 'maiz', 
    collider: { x: 125, y: 525, w: 330, h: 165 },
  },
  {
    id: 'corn2', name: 'Tierra de maíz 2', icon: '🌽', image: maizLand,
    x: 440, y: 410, width: 220, stateKey: 'maiz2', 
    collider: { x: 445, y: 525, w: 330, h: 165 },
  },
  {
    id: 'tree1', name: 'Tierra de árboles 1', icon: '🌳', image: arbol,
    x: 790, y: 145, width: 145, stateKey: 'arbol',  treeLand: true,
    collider: { x: 760, y: 245, w: 255, h: 165 },
  },
  {
    id: 'tree2', name: 'Tierra de árboles 2', icon: '🌳', image: arbol,
    x: 810, y: 390, width: 145, stateKey: 'arbol2',  treeLand: true,
    collider: { x: 780, y: 490, w: 255, h: 165 },
  },
  {
    id: 'tree3', name: 'Tierra de árboles 3', icon: '🌳', image: arbol,
    x: 760, y: 1030, width: 145, stateKey: 'arbol3',  treeLand: true,
    collider: { x: 730, y: 1130, w: 255, h: 165 },
  },
  {
    id: 'mill', name: 'Molino', icon: '⚙️', image: molinoLand,
    x: 1090, y: 150, width: 220, stateKey: null,
    collider: { x: 1125, y: 330, w: 165, h: 120 },
  },
  {
    id: 'water', name: 'Pozo de agua', icon: '💧', image: aguaLand,
    x: 1450, y: 225, width: 210, stateKey: 'agua',
    collider: { x: 1485, y: 365, w: 145, h: 110 },
  },
  {
    id: 'energy', name: 'Central eléctrica', icon: '⚡', image: energiaLand,
    x: 1860, y: 145, width: 335, stateKey: 'energia',
    collider: { x: 1900, y: 375, w: 270, h: 155 },
  },
  {
    id: 'cows', name: 'Granja de vacas', icon: '🐄', image: vacasLand,
    x: 240, y: 1015, width: 285, stateKey: 'granja2',
    collider: { x: 275, y: 1190, w: 235, h: 140 },
  },
  {
    id: 'home', name: 'Casa principal', icon: '🏡', image: casaLand,
    x: 1080, y: 1015, width: 250, stateKey: null,
    collider: { x: 1115, y: 1170, w: 185, h: 130 },
  },
  {
    id: 'chickens', name: 'Gallinero', icon: '🐔', image: gallinasLand,
    x: 1770, y: 1005, width: 285, stateKey: 'granja1',
    collider: { x: 1810, y: 1185, w: 230, h: 140 },
  },

  // FASE 13: los accesos del antiguo menú viven físicamente en el mapa.
  // El arte es 100% original y se dibuja con CSS (sin imágenes de terceros).
  // Todos estos edificios usan el mismo sistema ARRANGE/persistencia que el resto.
  {
    id: 'land-office', name: 'Oficina de Tierras', icon: '🌱', facility: true, facilityKind: 'lands',
    x: 2050, y: 320, width: 220, stateKey: null,
    collider: { x: 2080, y: 440, w: 165, h: 120 },
  },
  {
    id: 'inventory-warehouse', name: 'Almacén', icon: '🎒', facility: true, facilityKind: 'inventory',
    x: 2320, y: 320, width: 220, stateKey: null,
    collider: { x: 2350, y: 440, w: 165, h: 120 },
  },
  {
    id: 'objects-workshop', name: 'Taller de Objetos', icon: '📦', facility: true, facilityKind: 'objects',
    x: 2590, y: 320, width: 220, stateKey: null,
    collider: { x: 2620, y: 440, w: 165, h: 120 },
  },
  {
    id: 'packs-shop', name: 'Tienda de Packs', icon: '🎁', facility: true, facilityKind: 'packs',
    x: 2050, y: 690, width: 220, stateKey: null,
    collider: { x: 2080, y: 810, w: 165, h: 120 },
  },
  {
    id: 'trade-exchange', name: 'Mercado Trade', icon: '🔁', facility: true, facilityKind: 'trade',
    x: 2320, y: 690, width: 220, stateKey: null,
    collider: { x: 2350, y: 810, w: 165, h: 120 },
  },
  {
    id: 'pool-station', name: 'Estación Pool', icon: '💧', facility: true, facilityKind: 'pool',
    x: 2590, y: 690, width: 220, stateKey: null,
    collider: { x: 2620, y: 810, w: 165, h: 120 },
  },
  {
    id: 'profile-center', name: 'Perfil / Retiros', icon: '👤', facility: true, facilityKind: 'profile',
    x: 2295, y: 1365, width: 240, stateKey: null,
    collider: { x: 2330, y: 1495, w: 175, h: 125 },
  },
  {
    id: 'visit-station', name: 'Estación de Granjas', icon: '🚜', facility: true, facilityKind: 'visit',
    x: 2570, y: 1370, width: 240, stateKey: null,
    collider: { x: 2605, y: 1500, w: 175, h: 125 },
  },
  {
    id: 'bigdogbone-house', name: 'Casa Big Dog Bone', icon: '🐶', promo: 'bigdogbone',
    x: 2740, y: 1120, width: 280, stateKey: null,
    collider: { x: 2775, y: 1250, w: 210, h: 135 },
  },
];

const BUILDING_REAL_PANEL = {
  wheat: { type: 'wheat', selectorKey: 'trigo' },
  wheat2: { type: 'wheat', selectorKey: 'trigo2' },
  corn: { type: 'corn', selectorKey: 'maiz' },
  corn2: { type: 'corn', selectorKey: 'maiz2' },
  tree1: { type: 'tree', selectorKey: 'arbol' },
  tree2: { type: 'tree', selectorKey: 'arbol2' },
  tree3: { type: 'tree', selectorKey: 'arbol3' },
  mill: { type: 'mill' },
  water: { type: 'water', selectorKey: 'agua' },
  energy: { type: 'energy', selectorKey: 'energia' },
  cows: { type: 'cows', selectorKey: 'granja2' },
  chickens: { type: 'chickens', selectorKey: 'granja1' },
  home: { type: 'profile' },
  'land-office': { type: 'lands' },
  'inventory-warehouse': { type: 'inventory' },
  'objects-workshop': { type: 'objects' },
  'packs-shop': { type: 'packs' },
  'trade-exchange': { type: 'trade' },
  'pool-station': { type: 'pool' },
  'profile-center': { type: 'profile' },
  'visit-station': { type: 'visit' },
  'bigdogbone-house': { type: 'external', url: BIGDOG_BONE_URL },
};

// Acceso a TODAS las tierras reales, incluidas las secundarias que todavía
// no tienen un sprite propio en el mapa V2.
const REAL_LAND_SHORTCUTS = [
  { id: 'trigo', type: 'wheat', selectorKey: 'trigo', icon: '🌾', es: 'Trigo 1', en: 'Wheat 1' },
  { id: 'trigo2', type: 'wheat', selectorKey: 'trigo2', icon: '🌾', es: 'Trigo 2', en: 'Wheat 2' },
  { id: 'maiz', type: 'corn', selectorKey: 'maiz', icon: '🌽', es: 'Maíz 1', en: 'Corn 1' },
  { id: 'maiz2', type: 'corn', selectorKey: 'maiz2', icon: '🌽', es: 'Maíz 2', en: 'Corn 2' },
  { id: 'arbol', type: 'tree', selectorKey: 'arbol', icon: '🌳', es: 'Árbol 1', en: 'Tree 1' },
  { id: 'arbol2', type: 'tree', selectorKey: 'arbol2', icon: '🌳', es: 'Árbol 2', en: 'Tree 2' },
  { id: 'arbol3', type: 'tree', selectorKey: 'arbol3', icon: '🌳', es: 'Árbol 3', en: 'Tree 3' },
  { id: 'agua', type: 'water', selectorKey: 'agua', icon: '💧', es: 'Pozo de agua', en: 'Water well' },
  { id: 'energia', type: 'energy', selectorKey: 'energia', icon: '⚡', es: 'Central eléctrica', en: 'Power plant' },
  { id: 'granja2', type: 'cows', selectorKey: 'granja2', icon: '🐄', es: 'Granja de vacas', en: 'Cow farm' },
  { id: 'granja1', type: 'chickens', selectorKey: 'granja1', icon: '🐔', es: 'Gallinero', en: 'Chicken coop' },
  { id: 'molino', type: 'mill', selectorKey: null, icon: '⚙️', es: 'Molino', en: 'Mill' },
];

const BUILDING_NAMES = {
  es: {
    wheat: 'Trigo 1', wheat2: 'Trigo 2', corn: 'Maíz 1', corn2: 'Maíz 2',
    tree1: 'Árbol 1', tree2: 'Árbol 2', tree3: 'Árbol 3',
    mill: 'Molino', water: 'Pozo de agua', energy: 'Central eléctrica',
    cows: 'Granja de vacas', home: 'Casa / Perfil', chickens: 'Gallinero',
    'land-office': 'Oficina de Tierras', 'inventory-warehouse': 'Almacén', 'objects-workshop': 'Objetos / Tickets',
    'packs-shop': 'Tienda de Packs', 'trade-exchange': 'Mercado Trade', 'pool-station': 'Estación Pool',
    'profile-center': 'Perfil / Retiros', 'visit-station': 'Estación de Granjas', 'bigdogbone-house': 'Casa Big Dog Bone',
  },
  en: {
    wheat: 'Wheat 1', wheat2: 'Wheat 2', corn: 'Corn 1', corn2: 'Corn 2',
    tree1: 'Tree land 1', tree2: 'Tree land 2', tree3: 'Tree land 3',
    mill: 'Mill', water: 'Water well', energy: 'Power plant',
    cows: 'Cow farm', home: 'Home / Profile', chickens: 'Chicken coop',
    'land-office': 'Land Office', 'inventory-warehouse': 'Warehouse', 'objects-workshop': 'Objects / Tickets',
    'packs-shop': 'Packs Shop', 'trade-exchange': 'Trade Market', 'pool-station': 'Pool Station',
    'profile-center': 'Profile / Withdrawals', 'visit-station': 'Farm Station', 'bigdogbone-house': 'Big Dog Bone House',
  },
};

const I18N = {
  es: {
    beta: 'BETA · F13 · HUB EN EL MAPA', classic: '← Clásica', menu: 'MENÚ', close: 'Cerrar', logout: 'CERRAR SESIÓN', whitepaper: 'WHITEPAPER',
    interact: 'INTERACTUAR', approach: 'ACÉRCATE', world: 'MUNDO CITYFARM · ZONA CENTRAL · HORA UTC',
    moveTitle: 'Muévete por el mapa',
    moveHelp: 'Clic/arrastra para caminar · WASD/flechas · joystick móvil · E interactúa · ciclo real UTC',
    noBuilding: 'No hay ningún edificio suficientemente cerca.',
    moveCloser: 'Debes acercarte un poco más para interactuar.',
    locked: 'Esta tierra todavía está bloqueada. Desbloquéala desde Packs / progreso de CITYFARM.',
    realReady: 'Función real abierta. Todo lo que hagas aquí usa tu cuenta y backend actual.',
    nearby: 'EDIFICIO CERCANO', level: 'Nivel', distance: 'Distancia',
    realInfo: 'Esta construcción ya está conectada con la función real de CITYFARM.', openReal: 'ABRIR FUNCIÓN REAL', externalOpen: 'Abrir Big Dog Bone', externalOpened: 'Big Dog Bone abierto en una pestaña nueva.',
    language: 'Idioma', lands: 'TIERRAS', inventory: 'INVENTARIO', objects: 'OBJETOS', trade: 'TRADE',
    packs: 'PACKS', profile: 'PERFIL', pool: 'POOL',
    visit: 'VISITAR GRANJAS', landsTitle: 'Oficina de Tierras', backMenu: 'Volver', facilityHint: 'Acércate al edificio y usa INTERACTUAR.',
    lockedShort: 'BLOQ.', ready: 'LISTO', working: 'PRODUCIENDO', idle: 'LIBRE', hiveMissing: 'Hive sin asociar', plots: 'PARCELAS', lockedLand: 'BLOQUEADA', fitMap: 'VER TODO', zoom: 'ZOOM', weather: 'CLIMA', weatherAuto: 'AUTO', weatherHint: 'Clima automático · no requiere controles', routeBlocked: 'La ruta está bloqueada. Haz clic en otro punto del camino.', wetGround: 'SUELO HÚMEDO', productionReady: 'LISTO PARA RECOGER', productionActive: 'PRODUCIENDO', productionIdle: 'EN ESPERA', arrange: 'ORDENAR', doneArrange: 'LISTO', resetLayout: 'REINICIAR', arranging: 'Modo ordenar: cuadrícula de 20px activa. Mueve libremente y, al soltar, cada elemento queda alineado automáticamente. Las posiciones se guardan.', layoutSaved: 'Distribución guardada en tu cuenta CITYFARM y con respaldo local.', layers: 'CAPAS', layersTitle: 'Capas visuales', layersHint: 'Activa o desactiva elementos sin tocar la lógica real del juego.', resetLayers: 'RESTAURAR CAPAS', layersSaved: 'Preferencias visuales guardadas en este navegador.', roadEditor: 'CALLE', rotateRoad: 'GIRAR', changeRoad: 'CAMBIAR TRAMO', roadStraight: 'RECTA', roadCurve: 'CURVA', roadT: 'CRUCE T', roadCross: 'CRUCE +', expansionField: 'TIERRA SIMPLE', hide: 'OCULTAR', show: 'MOSTRAR', replace: 'REEMPLAZAR', roadReplacement: 'REEMPLAZO', noReplacement: 'CALLE', plazaEditor: 'PLAZA', plazaStyle: 'ESTILO', plazaAccessories: 'ACCESORIOS', fieldEditor: 'TIERRA SIMPLE', changeCropStyle: 'CAMBIAR ESTILO', creative: 'DECORAR', creativeTitle: 'Catálogo creativo', creativeHint: 'Añade decoración visual, muévela y guárdala automáticamente.', addDecoration: 'AGREGAR', removeDecoration: 'QUITAR', rotateDecoration: 'GIRAR', decorType: 'TIPO',
    phase: { 'Madrugada': 'MADRUGADA', 'Día': 'DÍA', 'Tarde': 'TARDE', 'Noche': 'NOCHE' },
  },
  en: {
    beta: 'BETA · P13 · WORLD HUB', classic: '← Classic', menu: 'MENU', close: 'Close', logout: 'LOG OUT', whitepaper: 'WHITEPAPER',
    interact: 'INTERACT', approach: 'GET CLOSER', world: 'CITYFARM WORLD · CENTRAL ZONE · UTC TIME',
    moveTitle: 'Move around the map',
    moveHelp: 'Click/drag to walk · WASD/arrows · mobile joystick · E interacts · real UTC cycle',
    noBuilding: 'There is no building close enough.',
    moveCloser: 'Move a little closer to interact.',
    locked: 'This land is still locked. Unlock it through Packs / CITYFARM progression.',
    realReady: 'Real feature opened. Everything you do here uses your current account and backend.',
    nearby: 'NEARBY BUILDING', level: 'Level', distance: 'Distance',
    realInfo: 'This building is now connected to the real CITYFARM feature.', openReal: 'OPEN REAL FEATURE', externalOpen: 'Open Big Dog Bone', externalOpened: 'Big Dog Bone opened in a new tab.',
    language: 'Language', lands: 'LANDS', inventory: 'INVENTORY', objects: 'OBJECTS', trade: 'TRADE',
    packs: 'PACKS', profile: 'PROFILE', pool: 'POOL',
    visit: 'VISIT FARMS', landsTitle: 'Land Office', backMenu: 'Back', facilityHint: 'Walk up to the building and use INTERACT.',
    lockedShort: 'LOCKED', ready: 'READY', working: 'WORKING', idle: 'IDLE', hiveMissing: 'Hive not linked', plots: 'PLOTS', lockedLand: 'LOCKED', fitMap: 'FIT FARM', zoom: 'ZOOM', weather: 'WEATHER', weatherAuto: 'AUTO', weatherHint: 'Automatic weather · no controls required', routeBlocked: 'The route is blocked. Click another point on the path.', wetGround: 'WET GROUND', productionReady: 'READY TO COLLECT', productionActive: 'WORKING', productionIdle: 'STANDBY', arrange: 'ARRANGE', doneArrange: 'DONE', resetLayout: 'RESET', arranging: 'Arrange mode: 20px grid active. Drag freely and every item snaps into alignment when released. Positions are saved.', layoutSaved: 'Layout saved to your CITYFARM account with a local backup.', layers: 'LAYERS', layersTitle: 'Visual layers', layersHint: 'Toggle elements on and off without changing the real game logic.', resetLayers: 'RESET LAYERS', layersSaved: 'Visual preferences saved in this browser.', roadEditor: 'ROAD', rotateRoad: 'ROTATE', changeRoad: 'CHANGE PIECE', roadStraight: 'STRAIGHT', roadCurve: 'CURVE', roadT: 'T JUNCTION', roadCross: 'CROSS', expansionField: 'SIMPLE FIELD', hide: 'HIDE', show: 'SHOW', replace: 'REPLACE', roadReplacement: 'REPLACEMENT', noReplacement: 'ROAD', plazaEditor: 'PLAZA', plazaStyle: 'STYLE', plazaAccessories: 'ACCESSORIES', fieldEditor: 'SIMPLE FIELD', changeCropStyle: 'CHANGE STYLE', creative: 'DECORATE', creativeTitle: 'Creative catalog', creativeHint: 'Add visual decorations, move them and save automatically.', addDecoration: 'ADD', removeDecoration: 'REMOVE', rotateDecoration: 'ROTATE', decorType: 'TYPE',
    phase: { 'Madrugada': 'EARLY', 'Día': 'DAY', 'Tarde': 'AFTERNOON', 'Noche': 'NIGHT' },
  },
};

const REAL_MODAL_STYLE = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '96%', md: '88%', lg: '82%' },
  maxWidth: '1180px',
  height: { xs: '92%', md: '90%' },
  maxHeight: '94vh',
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
  bgcolor: 'rgba(24, 26, 23, .98)',
  border: '2px solid #d9ad34',
  boxShadow: 24,
};

const getLandStatusKey = (land) => {
  if (!land?.habilitado) return 'lockedShort';
  if (!land?.tiempo) return 'idle';
  const end = new Date(land.tiempo).getTime();
  if (Number.isFinite(end) && end <= Date.now()) return 'ready';
  return 'working';
};

const getCropVisualState = (land) => {
  const status = getLandStatusKey(land);
  if (status === 'lockedShort') return 'locked';
  if (status === 'idle') return 'idle';
  if (status === 'ready') return 'ready';
  return 'growing';
};

const isCropBuilding = (building) =>
  ['wheat', 'wheat2', 'corn', 'corn2', 'tree1', 'tree2', 'tree3'].includes(building?.id);

const getDisplayImageForLevel = (building, level) => {
  const key = LEVEL_ART_ALIAS[building.id] || building.id;
  const list = LEVEL_ART[key];

  // Casa principal y cualquier objeto sin arte de niveles conservan su imagen base.
  if (!Array.isArray(list) || !list.length) return building.image;

  // CITYFARM clásico tiene 5 niveles visuales. Se limita solamente para
  // escoger el sprite; el nivel real sigue viniendo del backend/Redux.
  const safeLevel = Math.max(1, Math.min(list.length, Math.floor(Number(level) || 1)));
  return list[safeLevel - 1] || building.image;
};

const cropIconFor = (building, state) => {
  if (state === 'idle') return '＋';
  if (state === 'ready') return building?.id?.startsWith('corn') ? '🌽' : building?.id?.startsWith('tree') ? '🍎' : '🌾';
  if (state === 'growing') return building?.id?.startsWith('tree') ? '🌱' : '🌿';
  return '';
};

const parseTimeMs = (value) => {
  if (!value) return NaN;
  const time = new Date(value).getTime();
  return Number.isFinite(time) ? time : NaN;
};

const getCycleHours = (land) => firstFiniteNumber(
  land?.tiempoProduccion,
  land?.productionTime,
  land?.productionHours,
  land?.tiempoHoras,
  0
);

// Para cultivos y granjas animales, "tiempo" es el momento en que termina.
// Para agua/energía, "tiempo" es el último claim y tiempoProduccion marca cada ciclo.
// Esta función SOLO interpreta datos que ya llegaron del backend.
const getProductionTelemetry = (land, mode = 'timed') => {
  if (!land?.habilitado) {
    return { status: 'locked', progress: 0, stage: 0, readyUnits: 0 };
  }

  const rawTime = land?.tiempo;
  if (rawTime === '' || rawTime === null || rawTime === undefined) {
    return { status: 'idle', progress: 0, stage: 0, readyUnits: 0 };
  }

  const stamp = parseTimeMs(rawTime);
  if (!Number.isFinite(stamp)) {
    return { status: 'working', progress: .45, stage: 2, readyUnits: 0 };
  }

  const now = Date.now();
  const cycleHours = getCycleHours(land);
  const cycleMs = cycleHours > 0 ? cycleHours * 3600000 : 0;

  if (mode === 'continuous') {
    const elapsed = Math.max(0, now - stamp);
    if (!cycleMs) {
      return { status: 'working', progress: .5, stage: 2, readyUnits: 0 };
    }

    const readyUnits = Math.max(0, Math.floor(elapsed / cycleMs));
    const progress = Math.max(0, Math.min(1, (elapsed % cycleMs) / cycleMs));
    return {
      status: readyUnits > 0 ? 'ready' : 'working',
      progress,
      stage: progress < .34 ? 1 : progress < .72 ? 2 : 3,
      readyUnits,
    };
  }

  if (stamp <= now) {
    return { status: 'ready', progress: 1, stage: 4, readyUnits: 1 };
  }

  const remaining = Math.max(0, stamp - now);
  const progress = cycleMs
    ? Math.max(0, Math.min(1, 1 - remaining / cycleMs))
    : .5;

  return {
    status: 'working',
    progress,
    stage: progress < .25 ? 1 : progress < .6 ? 2 : progress < .88 ? 3 : 4,
    readyUnits: 0,
  };
};

const getBuildingTelemetry = (building, land) => {
  if (!building?.stateKey) return null;
  if (building.id === 'water' || building.id === 'energy') {
    return getProductionTelemetry(land, 'continuous');
  }
  return getProductionTelemetry(land, 'timed');
};

const isRestPhase = (phase) => phase === 'Noche' || phase === 'Madrugada';



const TREES = [
  [80, 120], [120, 410], [80, 970], [125, 1310], [520, 120], [590, 1260],
  [930, 120], [990, 1340], [1390, 120], [1440, 1320], [1810, 100], [2150, 120],
  [2240, 460], [2210, 940], [2160, 1320], [650, 610], [1700, 620], [740, 880],
  [1630, 900], [1450, 860],
];

const LAMPS = [
  [610, 675], [870, 675], [1030, 675], [1370, 675], [1540, 675], [1780, 675],
  [1090, 500], [1310, 500], [1090, 1045], [1310, 1045], [1880, 930], [610, 930],
];

const TREE_DECOR = TREES.map(([x, y], index) => ({
  id: `tree-decor-${index + 1}`,
  x,
  y,
  width: 115,
  height: 125,
}));

const LAMP_DECOR = LAMPS.map(([x, y], index) => ({
  id: `lamp-decor-${index + 1}`,
  x,
  y,
  width: 24,
  height: 62,
}));


const LAKE_DECOR = {
  id: 'lake-decor-main',
  x: 2690,
  y: 1320,
  width: 540,
  height: 320,
};


// El río grande completo se guarda como una sola decoración visual.
// Los límites permiten moverlo bastante, pero el SVG siempre se recorta
// dentro del mapa para que nunca se vea fuera de los bordes.
const RIVER_DECOR = {
  id: 'river-decor-main',
  x: 0,
  y: 0,
  width: 3400,
  height: 700,
  minX: -520,
  maxX: 520,
  minY: -120,
  maxY: 1220,
};


const ROAD_TILE_SIZE = 460;
const ROAD_TYPES = ['straight', 'curve', 't', 'cross'];
const ROAD_PATHS = {
  straight: ['M 0 230 L 460 230'],
  curve: ['M 0 230 C 145 230 230 230 230 460'],
  t: ['M 0 230 L 460 230', 'M 230 230 L 230 460'],
  cross: ['M 0 230 L 460 230', 'M 230 0 L 230 460'],
};

const ROAD_PIECES = [
  { id: 'road-01', kind: 'straight', x: 0, y: 820, rotation: 0 },
  { id: 'road-02', kind: 'straight', x: 440, y: 820, rotation: 0 },
  { id: 'road-03', kind: 'straight', x: 880, y: 820, rotation: 0 },
  { id: 'road-04', kind: 'cross', x: 1320, y: 820, rotation: 0 },
  { id: 'road-05', kind: 'straight', x: 1760, y: 820, rotation: 0 },
  { id: 'road-06', kind: 'straight', x: 2200, y: 820, rotation: 0 },
  { id: 'road-07', kind: 'straight', x: 2640, y: 820, rotation: 0 },
  { id: 'road-08', kind: 'straight', x: 3080, y: 820, rotation: 0 },
  { id: 'road-09', kind: 'straight', x: 1450, y: 0, rotation: 90 },
  { id: 'road-10', kind: 'straight', x: 1450, y: 440, rotation: 90 },
  { id: 'road-11', kind: 'cross', x: 1450, y: 880, rotation: 90 },
  { id: 'road-12', kind: 'straight', x: 1450, y: 1320, rotation: 90 },
  { id: 'road-13', kind: 'straight', x: 1450, y: 1740, rotation: 90 },
  { id: 'road-14', kind: 'straight', x: 1030, y: 630, rotation: 0 },
  { id: 'road-15', kind: 't', x: 1470, y: 630, rotation: 0 },
  { id: 'road-16', kind: 'straight', x: 1910, y: 630, rotation: 0 },
  { id: 'road-17', kind: 'straight', x: 1030, y: 1180, rotation: 0 },
  { id: 'road-18', kind: 't', x: 1470, y: 1180, rotation: 180 },
  { id: 'road-19', kind: 'straight', x: 1910, y: 1180, rotation: 0 },
];

const PLAZA_DECOR = {
  id: 'plaza-decor-main',
  x: 1580,
  y: 975,
  width: 360,
  height: 300,
};

const SIMPLE_FIELDS = [
  { id: 'simple-field-1', x: 260, y: 1710, width: 300, height: 190, variant: 0 },
  { id: 'simple-field-2', x: 650, y: 1780, width: 300, height: 190, variant: 1 },
  { id: 'simple-field-3', x: 2510, y: 1735, width: 300, height: 190, variant: 2 },
  { id: 'simple-field-4', x: 2910, y: 1660, width: 300, height: 190, variant: 0 },
  { id: 'simple-field-5', x: 3070, y: 780, width: 300, height: 190, variant: 1 },
  { id: 'simple-field-6', x: 3150, y: 1230, width: 300, height: 190, variant: 2 },
];

const ROAD_REPLACEMENTS = ['none', 'lamp', 'tree', 'garden', 'rock', 'bench', 'sign'];
const FLOOR_BASE_TYPES = ['ground-grass', 'ground-stone', 'ground-wood', 'ground-dirt'];
const FLOOR_TYPES = FLOOR_BASE_TYPES.flatMap((type) => [type, `${type}-2x2`, `${type}-3x3`]);
const FENCE_TYPES = ['fence-wood', 'fence-wood-long', 'fence-corner', 'fence-gate'];
const DECOR_TYPES = ['lamp', 'tree', 'garden', 'rock', 'bench', 'sign', 'fountain'];
const CREATIVE_DECOR_TYPES = [...DECOR_TYPES, ...FLOOR_TYPES, ...FENCE_TYPES];
const getDecorSize = (type) => type.endsWith('-3x3') ? 384 : (type.endsWith('-2x2') ? 256 : 128);
const getFloorBase = (type) => type.replace(/-(?:2x2|3x3)$/, '');
const CREATIVE_DECOR_LABELS = {
  lamp: { es: 'Farola', en: 'Lamp' },
  tree: { es: 'Árbol', en: 'Tree' },
  garden: { es: 'Jardín', en: 'Garden' },
  rock: { es: 'Rocas', en: 'Rocks' },
  bench: { es: 'Banco', en: 'Bench' },
  sign: { es: 'Señal', en: 'Sign' },
  fountain: { es: 'Fuente', en: 'Fountain' },
  'ground-grass': { es: 'Pieza de césped', en: 'Grass tile' },
  'ground-stone': { es: 'Piso de piedra', en: 'Stone floor' },
  'ground-wood': { es: 'Piso de madera', en: 'Wood deck' },
  'ground-dirt': { es: 'Suelo de tierra', en: 'Dirt tile' },
  'ground-grass-2x2': { es: 'Césped 2x2', en: 'Grass 2x2' },
  'ground-grass-3x3': { es: 'Césped 3x3', en: 'Grass 3x3' },
  'ground-stone-2x2': { es: 'Piedra 2x2', en: 'Stone 2x2' },
  'ground-stone-3x3': { es: 'Piedra 3x3', en: 'Stone 3x3' },
  'ground-wood-2x2': { es: 'Madera 2x2', en: 'Wood 2x2' },
  'ground-wood-3x3': { es: 'Madera 3x3', en: 'Wood 3x3' },
  'ground-dirt-2x2': { es: 'Tierra 2x2', en: 'Dirt 2x2' },
  'ground-dirt-3x3': { es: 'Tierra 3x3', en: 'Dirt 3x3' },
  'fence-wood': { es: 'Cerca de madera', en: 'Wood fence' },
  'fence-wood-long': { es: 'Cerca larga', en: 'Long fence' },
  'fence-corner': { es: 'Cerca de esquina', en: 'Corner fence' },
  'fence-gate': { es: 'Portón de madera', en: 'Wood gate' },
};
const PLAZA_STYLES = ['stone', 'garden', 'rural', 'cityfarm'];
const PLAZA_ACCESSORIES = ['fountain', 'tree', 'flowers', 'bench', 'lamps', 'sign'];
const MAX_CREATIVE_DECOR = 144;
const DEFAULT_GARDEN_PATCHES = [
  { id: 'creative-decor-01', x: 520, y: 440, type: 'garden', rotation: 0, visible: true },
  { id: 'creative-decor-02', x: 690, y: 470, type: 'garden', rotation: 90, visible: true },
  { id: 'creative-decor-03', x: 2260, y: 420, type: 'garden', rotation: 0, visible: true },
  { id: 'creative-decor-04', x: 2440, y: 460, type: 'garden', rotation: 90, visible: true },
  { id: 'creative-decor-05', x: 720, y: 1530, type: 'garden', rotation: 0, visible: true },
  { id: 'creative-decor-06', x: 910, y: 1600, type: 'garden', rotation: 180, visible: true },
  { id: 'creative-decor-07', x: 2230, y: 1460, type: 'garden', rotation: 0, visible: true },
  { id: 'creative-decor-08', x: 2410, y: 1540, type: 'garden', rotation: 270, visible: true },
];

const CreativeDecorVisual = ({ type = 'lamp' }) => (
  <span className={`cfv2-creative-visual decor-${type}`} aria-hidden="true">
    <i className="part-a" />
    <i className="part-b" />
    <i className="part-c" />
    <i className="part-d" />
  </span>
);


// Arte original CITYFARM: edificios vectoriales dibujados con CSS.
// No usa sprites, logos ni imágenes externas con copyright.
const FacilityBuildingVisual = ({ kind = 'inventory', icon = '🏠' }) => (
  <span className={`cfv2-facility-art facility-${kind}`} aria-hidden="true">
    <i className="cfv2-facility-shadow" />
    <i className="cfv2-facility-base" />
    <i className="cfv2-facility-wall" />
    <i className="cfv2-facility-roof" />
    <i className="cfv2-facility-door" />
    <i className="cfv2-facility-window window-a" />
    <i className="cfv2-facility-window window-b" />
    <i className="cfv2-facility-sign"><b>{icon}</b></i>
    <i className="cfv2-facility-detail detail-a" />
    <i className="cfv2-facility-detail detail-b" />
  </span>
);

const BigDogBoneHouseVisual = () => (
  <span className="cfv2-bigdog-house-art" aria-hidden="true">
    <i className="cfv2-bigdog-shadow" />
    <i className="cfv2-bigdog-house-body" />
    <i className="cfv2-bigdog-house-roof" />
    <i className="cfv2-bigdog-house-door" />
    <span className="cfv2-bigdog-logo-sign">
      <img src={bigDogBoneLogo} alt="" draggable="false" />
    </span>
    <span className="cfv2-bigdog-pitbull">
      <i className="dog-body" />
      <i className="dog-head" />
      <i className="dog-ear ear-a" />
      <i className="dog-ear ear-b" />
      <i className="dog-leg leg-a" />
      <i className="dog-leg leg-b" />
      <i className="dog-tail" />
    </span>
  </span>
);

const POST_WEATHER_DEBRIS = [
  [420, 620, -12], [730, 1500, 8], [1120, 1630, -8], [2050, 1510, 12],
  [2470, 1180, -16], [2780, 720, 7], [3040, 1440, -9], [3350, 980, 14],
  [940, 730, 5], [2300, 1760, -13], [1540, 570, 11], [1880, 1670, -5],
];

const SHIFTED_PUDDLES = PUDDLES.map(([x, y, width, height]) => [x + MAP_SHIFT.x, y + MAP_SHIFT.y, width, height]);
const SHIFTED_TRAFFIC = ROAD_TRAFFIC.map((item) => ({ ...item, x: item.x + MAP_SHIFT.x, y: item.y + MAP_SHIFT.y }));
const SHIFTED_NPCS = WORLD_NPCS.map((item) => ({ ...item, x: item.x + MAP_SHIFT.x, y: item.y + MAP_SHIFT.y }));
const SHIFTED_CLOUDS = CLOUDS.map((item) => ({ ...item, x: item.x + MAP_SHIFT.x, y: item.y + MAP_SHIFT.y }));

const RIVER_PATH = `
  M 170 250
  C 450 170, 760 340, 1080 255
  C 1410 170, 1760 165, 2080 248
  C 2380 326, 2670 364, 2945 312
  C 3070 288, 3200 302, 3228 385
  L 3228 525
  C 3228 570, 3282 602, 3368 598
  C 3444 595, 3508 582, 3556 560
`;

const RIVER_ROCKS = [
  { id: 'rock-1', x: 420, y: 214, rx: 26, ry: 15, rotate: -10 },
  { id: 'rock-2', x: 760, y: 308, rx: 22, ry: 13, rotate: 8 },
  { id: 'rock-3', x: 1140, y: 236, rx: 28, ry: 17, rotate: -5 },
  { id: 'rock-4', x: 1590, y: 212, rx: 24, ry: 14, rotate: 10 },
  { id: 'rock-5', x: 2040, y: 230, rx: 20, ry: 12, rotate: -8 },
  { id: 'rock-6', x: 2480, y: 330, rx: 26, ry: 15, rotate: -12 },
  { id: 'rock-7', x: 2840, y: 330, rx: 22, ry: 13, rotate: 6 },
  { id: 'rock-8', x: 3170, y: 360, rx: 26, ry: 15, rotate: -4 },
  { id: 'rock-9', x: 3230, y: 610, rx: 28, ry: 16, rotate: 7 },
  { id: 'rock-10', x: 3410, y: 575, rx: 24, ry: 14, rotate: -9 },
];

const RIVER_REEDS = [
  { id: 'reed-1', x: 308, y: 175, h: 25, side: 'north', tilt: -10 },
  { id: 'reed-2', x: 590, y: 308, h: 22, side: 'south', tilt: 10 },
  { id: 'reed-3', x: 948, y: 205, h: 29, side: 'north', tilt: -8 },
  { id: 'reed-4', x: 1322, y: 176, h: 27, side: 'north', tilt: 7 },
  { id: 'reed-5', x: 1896, y: 190, h: 24, side: 'north', tilt: -11 },
  { id: 'reed-6', x: 2310, y: 332, h: 28, side: 'south', tilt: 9 },
  { id: 'reed-7', x: 2745, y: 368, h: 25, side: 'south', tilt: -9 },
  { id: 'reed-8', x: 3330, y: 566, h: 26, side: 'south', tilt: 12 },
];

const RIVER_LILIES = [
  { id: 'lily-1', x: 640, y: 250, r: 12 },
  { id: 'lily-2', x: 1735, y: 220, r: 10 },
  { id: 'lily-3', x: 2570, y: 330, r: 11 },
  { id: 'lily-4', x: 3470, y: 572, r: 9 },
];

const RIVER_BEACHES = [
  { id: 'beach-1', x: 420, y: 122, rx: 118, ry: 36, rotate: -9 },
  { id: 'beach-2', x: 1520, y: 104, rx: 92, ry: 28, rotate: 8 },
  { id: 'beach-3', x: 2660, y: 182, rx: 104, ry: 30, rotate: -11 },
  { id: 'beach-4', x: 3355, y: 564, rx: 84, ry: 25, rotate: 5 },
];

const RIVER_SIDE_FOAM = [
  { id: 'foam-1', x: 765, y: 160, rx: 38, ry: 9, rotate: -6 },
  { id: 'foam-2', x: 1210, y: 136, rx: 30, ry: 8, rotate: 4 },
  { id: 'foam-3', x: 1950, y: 132, rx: 44, ry: 9, rotate: -7 },
  { id: 'foam-4', x: 2840, y: 260, rx: 36, ry: 8, rotate: 12 },
  { id: 'foam-5', x: 3435, y: 480, rx: 34, ry: 8, rotate: -8 },
];

const DEFAULT_LAYER_VISIBILITY = {
  river: true,
  roads: true,
  fields: true,
  decorations: true,
  labels: true,
  traffic: true,
  animals: true,
  trees: true,
  lamps: true,
  weather: true,
  particles: true,
};

const LAYER_DEFS = [
  { id: 'river', icon: '🌊', es: 'Río', en: 'River' },
  { id: 'roads', icon: '🛣️', es: 'Calles', en: 'Roads' },
  { id: 'fields', icon: '🌱', es: 'Cultivos simples', en: 'Simple fields' },
  { id: 'decorations', icon: '✨', es: 'Decoraciones', en: 'Decorations' },
  { id: 'labels', icon: '🏷️', es: 'Etiquetas', en: 'Labels' },
  { id: 'traffic', icon: '🚜', es: 'Tráfico', en: 'Traffic' },
  { id: 'animals', icon: '🐾', es: 'Animales', en: 'Animals' },
  { id: 'trees', icon: '🌳', es: 'Árboles', en: 'Trees' },
  { id: 'lamps', icon: '💡', es: 'Luces', en: 'Lamps' },
  { id: 'weather', icon: '⛅', es: 'Clima', en: 'Weather' },
  { id: 'particles', icon: '✨', es: 'Efectos', en: 'Effects' },
];


// Animales decorativos de la V2. Se mueven solo en el frontend; todavía no
// alteran producción, inventario ni economía de CITYFARM.
const ANIMALS = [
  // Los siete originales conservan sus posiciones. Los nuevos son sólo visuales.
  { id: 'cow-1', type: 'cow', image: vacaSprite, x: 420, y: 1135, size: 92, route: 'cow-a', duration: 31, delay: -3 },
  { id: 'cow-2', type: 'cow', image: vacaSprite, x: 505, y: 1240, size: 86, route: 'cow-b', duration: 36, delay: -11 },
  { id: 'cow-3', type: 'cow', image: vacaSprite, x: 245, y: 1270, size: 82, route: 'cow-c', duration: 34, delay: -7 },
  { id: 'hen-1', type: 'chicken', image: gallinaSprite, x: 1820, y: 1185, size: 56, route: 'hen-a', duration: 20, delay: -2 },
  { id: 'hen-2', type: 'chicken', image: gallinaSprite, x: 1940, y: 1260, size: 54, route: 'hen-b', duration: 23, delay: -8 },
  { id: 'hen-3', type: 'chicken', image: gallinaSprite, x: 1700, y: 1265, size: 52, route: 'hen-c', duration: 19, delay: -4 },
  { id: 'rooster-1', type: 'rooster', image: galloSprite, x: 1885, y: 1125, size: 58, route: 'rooster-a', duration: 26, delay: -6 },
  // Distribución suave por las nuevas extensiones, evitando agua y la calle principal.
  { id: 'cow-field-east-1', type: 'cow', image: vacaSprite, x: 3430, y: 1280, size: 90, route: 'cow-b', duration: 42, delay: -13 },
  { id: 'cow-field-east-2', type: 'cow', image: vacaSprite, x: 4450, y: 2000, size: 94, route: 'cow-a', duration: 40, delay: -19 },
  { id: 'cow-field-south-1', type: 'cow', image: vacaSprite, x: 1140, y: 2880, size: 90, route: 'cow-c', duration: 39, delay: -10 },
  { id: 'cow-field-south-2', type: 'cow', image: vacaSprite, x: 3210, y: 3050, size: 90, route: 'cow-b', duration: 45, delay: -17 },
  { id: 'hen-field-east-1', type: 'chicken', image: gallinaSprite, x: 3720, y: 1720, size: 55, route: 'hen-c', duration: 22, delay: -11 },
  { id: 'hen-field-east-2', type: 'chicken', image: gallinaSprite, x: 4700, y: 2600, size: 55, route: 'hen-a', duration: 24, delay: -9 },
  { id: 'hen-field-south-1', type: 'chicken', image: gallinaSprite, x: 1820, y: 2920, size: 53, route: 'hen-b', duration: 22, delay: -12 },
  { id: 'hen-field-south-2', type: 'chicken', image: gallinaSprite, x: 2820, y: 3280, size: 54, route: 'hen-c', duration: 23, delay: -18 },
  { id: 'rooster-field-east', type: 'rooster', image: galloSprite, x: 4220, y: 1390, size: 59, route: 'rooster-a', duration: 28, delay: -11 },
  { id: 'rooster-field-south', type: 'rooster', image: galloSprite, x: 2080, y: 3350, size: 59, route: 'rooster-a', duration: 28, delay: -16 },
  // Grupos adicionales, sólo decorativos y sin colisión.
  { id: 'cow-meadow-west', type: 'cow', image: vacaSprite, x: 1050, y: 2050, size: 136, route: 'cow-b', duration: 44, delay: -8 },
  { id: 'cow-meadow-west-2', type: 'cow', image: vacaSprite, x: 1250, y: 2180, size: 130, route: 'cow-c', duration: 49, delay: -21 },
  { id: 'cow-meadow-east', type: 'cow', image: vacaSprite, x: 4050, y: 1760, size: 136, route: 'cow-a', duration: 46, delay: -14 },
  { id: 'cow-meadow-south', type: 'cow', image: vacaSprite, x: 3650, y: 3450, size: 138, route: 'cow-b', duration: 48, delay: -9 },
  { id: 'hen-meadow-west', type: 'chicken', image: gallinaSprite, x: 1470, y: 2340, size: 84, route: 'hen-b', duration: 24, delay: -13 },
  { id: 'hen-meadow-east', type: 'chicken', image: gallinaSprite, x: 4330, y: 2250, size: 84, route: 'hen-a', duration: 26, delay: -16 },
  { id: 'rooster-meadow-south', type: 'rooster', image: galloSprite, x: 2570, y: 3500, size: 88, route: 'rooster-a', duration: 29, delay: -7 },
];

const FIREFLIES = [
  [520, 930], [670, 980], [820, 1220], [1450, 1010], [1570, 1190], [2080, 1030],
  [330, 860], [2020, 650], [690, 430], [1650, 430], [2240, 760], [155, 760],
];

const SHIFTED_ANIMALS = ANIMALS.map((item) => ({ ...item, x: item.x + MAP_SHIFT.x, y: item.y + MAP_SHIFT.y }));
const SHIFTED_FIREFLIES = FIREFLIES.map(([x, y]) => [x + MAP_SHIFT.x, y + MAP_SHIFT.y]);

const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

const migrateLegacyWorldLayout = (layout) => {
  if (!layout || typeof layout !== 'object' || Array.isArray(layout)) return {};
  const next = { ...layout };
  const bigDog = next['bigdogbone-house'];

  // PHASE 17 inicial guardó la casa demasiado a la derecha (3000,1380).
  // Si esa coordenada antigua quedó persistida en local/Mongo, migrarla una sola vez.
  if (
    bigDog
    && Number(bigDog.x) === 3000
    && Number(bigDog.y) === 1380
  ) {
    next['bigdogbone-house'] = { ...bigDog, x: 2740, y: 1120 };
  }

  return next;
};

const snapToArrangeGrid = (value, max, step = ARRANGE_GRID_SIZE) => {
  const safeMax = Math.max(0, Math.floor((Number(max) || 0) / step) * step);
  return clamp(Math.round((Number(value) || 0) / step) * step, 0, safeMax);
};

const getProfessionalReleaseSnap = ({
  rawX,
  rawY,
  maxX,
  maxY,
  itemWidth = 0,
  candidates = [],
  threshold = ARRANGE_RELEASE_ALIGN_THRESHOLD,
}) => {
  let finalX = snapToArrangeGrid(rawX, maxX, ARRANGE_GRID_SIZE);
  let finalY = snapToArrangeGrid(rawY, maxY, ARRANGE_GRID_SIZE);
  let bestXDistance = threshold + 1;
  let bestYDistance = threshold + 1;

  candidates.forEach((candidate) => {
    const peerX = Number(candidate?.x);
    const peerY = Number(candidate?.y);
    const peerWidth = firstFiniteNumber(candidate?.width, itemWidth);

    if (Number.isFinite(peerX)) {
      const alignedLeft = Math.round(peerX);
      const alignedCenter = Math.round(peerX + (peerWidth / 2) - (itemWidth / 2));
      const alignedRight = Math.round(peerX + peerWidth - itemWidth);
      [alignedLeft, alignedCenter, alignedRight].forEach((snapX) => {
        const distance = Math.abs((Number(rawX) || 0) - snapX);
        if (distance <= threshold && distance < bestXDistance) {
          finalX = clamp(snapX, 0, Math.max(0, Number(maxX) || 0));
          bestXDistance = distance;
        }
      });
    }

    if (Number.isFinite(peerY)) {
      const alignedTop = Math.round(peerY);
      const distance = Math.abs((Number(rawY) || 0) - alignedTop);
      if (distance <= threshold && distance < bestYDistance) {
        finalY = clamp(alignedTop, 0, Math.max(0, Number(maxY) || 0));
        bestYDistance = distance;
      }
    }
  });

  // Importante: cualquier alineación con otra estructura vuelve a caer sobre
  // una línea real de la cuadrícula. Nunca dejamos una coordenada "entre celdas".
  finalX = snapToArrangeGrid(finalX, maxX, ARRANGE_GRID_SIZE);
  finalY = snapToArrangeGrid(finalY, maxY, ARRANGE_GRID_SIZE);

  return { x: finalX, y: finalY };
};

const snapDecorAnchorToGrid = ({
  rawX,
  rawY,
  width,
  height,
  minX,
  maxX,
  minY,
  maxY,
  step = ARRANGE_GRID_SIZE,
}) => {
  const safeMinX = Number(minX) || 0;
  const safeMinY = Number(minY) || 0;
  const safeMaxX = Number(maxX) || Math.max(0, WORLD.width - (Number(width) || 0));
  const safeMaxY = Number(maxY) || Math.max(0, WORLD.height - (Number(height) || 0));

  const snappedX = Math.round((Number(rawX) || 0) / step) * step;
  const snappedY = Math.round((Number(rawY) || 0) / step) * step;

  return {
    x: clamp(snappedX, safeMinX, Math.floor(safeMaxX / step) * step),
    y: clamp(snappedY, safeMinY, Math.floor(safeMaxY / step) * step),
  };
};

const getArrangeSlotRect = (item) => {
  const width = Math.max(ARRANGE_GRID_SIZE, Math.ceil((Number(item?.width) || ARRANGE_GRID_SIZE) / ARRANGE_GRID_SIZE) * ARRANGE_GRID_SIZE);
  const height = Math.max(ARRANGE_GRID_SIZE, Math.ceil((Number(item?.height) || ARRANGE_GRID_SIZE) / ARRANGE_GRID_SIZE) * ARRANGE_GRID_SIZE);
  return {
    x: Number(item?.x) || 0,
    y: Number(item?.y) || 0,
    width,
    height,
  };
};

const decorRectsOverlap = (a, b, gap = 4) => (
  a.x < b.x + b.width + gap
  && a.x + a.width + gap > b.x
  && a.y < b.y + b.height + gap
  && a.y + a.height + gap > b.y
);

const findNearestFreeDecorGridSpot = ({
  x,
  y,
  width,
  height,
  minX,
  maxX,
  minY,
  maxY,
  occupied = [],
  step = ARRANGE_GRID_SIZE,
}) => {
  const base = getArrangeSlotRect({ x, y, width, height });
  if (!occupied.some((peer) => decorRectsOverlap(base, peer))) return { x, y };

  // Busca alrededor del punto soltado por anillos. Esto evita apilar dos
  // piezas en el mismo espacio sin mandar el objeto lejos.
  for (let ring = 1; ring <= 8; ring += 1) {
    const offsets = [];
    for (let dx = -ring; dx <= ring; dx += 1) {
      offsets.push([dx, -ring], [dx, ring]);
    }
    for (let dy = -ring + 1; dy <= ring - 1; dy += 1) {
      offsets.push([-ring, dy], [ring, dy]);
    }

    for (const [gx, gy] of offsets) {
      const candidate = snapDecorAnchorToGrid({
        rawX: x + (gx * step),
        rawY: y + (gy * step),
        width,
        height,
        minX,
        maxX,
        minY,
        maxY,
        step,
      });
      const rect = getArrangeSlotRect({ ...candidate, width, height });
      if (!occupied.some((peer) => decorRectsOverlap(rect, peer))) {
        return candidate;
      }
    }
  }

  return { x, y };
};

const getArrangeFrameStyle = (width, height) => {
  const w = Math.max(1, Number(width) || ARRANGE_GRID_SIZE);
  const h = Math.max(1, Number(height) || ARRANGE_GRID_SIZE);
  const slotW = Math.ceil(w / ARRANGE_GRID_SIZE) * ARRANGE_GRID_SIZE;
  const slotH = Math.ceil(h / ARRANGE_GRID_SIZE) * ARRANGE_GRID_SIZE;
  return {
    '--cfv2-grid-frame-left': '0px',
    '--cfv2-grid-frame-top': '0px',
    '--cfv2-grid-frame-width': `${slotW}px`,
    '--cfv2-grid-frame-height': `${slotH}px`,
  };
};

const firstFiniteNumber = (...values) => {
  for (const value of values) {
    const n = Number(value);
    if (Number.isFinite(n)) return n;
  }
  return 0;
};

const formatNumber = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0';
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(n);
};

const getInventoryAmount = (informacion, keywords) => {
  const inventory = informacion?.inventario || [];
  const normalized = keywords.map((key) => String(key).toLowerCase());
  const found = inventory.find((entry) => {
    const item = String(entry?.item || '').toLowerCase();
    return normalized.some((key) => item.includes(key));
  });
  return firstFiniteNumber(found?.cantidad, 0);
};

const getBuildingLevel = (informacion, building) => {
  if (building.id === 'mill') {
    return firstFiniteNumber(
      informacion?.molinoNivel,
      informacion?.molino?.nivel,
      informacion?.mill?.level,
      1
    );
  }

  if (!building.stateKey) return firstFiniteNumber(informacion?.nivel, informacion?.level, 1);

  const state = informacion?.tierras?.[building.stateKey] || {};
  return firstFiniteNumber(state?.nivel, state?.level, state?.lvl, 1);
};

const intersects = (a, b) =>
  a.x < b.x + b.w &&
  a.x + a.w > b.x &&
  a.y < b.y + b.h &&
  a.y + a.h > b.y;

const distanceToRect = (x, y, rect) => {
  const nearestX = clamp(x, rect.x, rect.x + rect.w);
  const nearestY = clamp(y, rect.y, rect.y + rect.h);
  return Math.hypot(x - nearestX, y - nearestY);
};

const getDayCycle = () => {
  // Ciclo REAL sincronizado con UTC. No está acelerado.
  const now = new Date();
  const hours = now.getUTCHours();
  const minutes = now.getUTCMinutes();
  const seconds = now.getUTCSeconds();
  const hour = hours + minutes / 60 + seconds / 3600;

  // Fases visibles solicitadas para CITYFARM V2 (UTC):
  // 00:00-05:59 Madrugada | 06:00-11:59 Día | 12:00-18:59 Tarde | 19:00-23:59 Noche
  let phase = 'Madrugada';
  let icon = '🌙';
  if (hour >= 6 && hour < 12) {
    phase = 'Día';
    icon = '☀️';
  } else if (hour >= 12 && hour < 19) {
    phase = 'Tarde';
    icon = '🌤️';
  } else if (hour >= 19) {
    phase = 'Noche';
    icon = '🌙';
  }

  // Iluminación progresiva alrededor de amanecer/atardecer, manteniendo
  // las etiquetas de fase anteriores.
  let nightOpacity = 0;
  if (hour < 5) {
    nightOpacity = 0.58;
  } else if (hour < 7) {
    nightOpacity = 0.58 * (1 - (hour - 5) / 2);
  } else if (hour < 18) {
    nightOpacity = 0;
  } else if (hour < 20) {
    nightOpacity = 0.58 * ((hour - 18) / 2);
  } else {
    nightOpacity = 0.58;
  }

  let warmOpacity = 0;
  if (hour >= 5 && hour < 7.5) {
    warmOpacity = Math.sin(((hour - 5) / 2.5) * Math.PI) * 0.15;
  }
  if (hour >= 16 && hour < 20) {
    warmOpacity = Math.max(
      warmOpacity,
      Math.sin(((hour - 16) / 4) * Math.PI) * 0.20
    );
  }

  const timeLabel = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;

  return {
    phase,
    icon,
    timeLabel,
    utcLabel: `${timeLabel} UTC`,
    nightOpacity: clamp(nightOpacity, 0, 0.58),
    warmOpacity: clamp(warmOpacity, 0, 0.20),
    lampOpacity: clamp(nightOpacity / 0.58, 0, 1),
    fireflyOpacity: clamp((nightOpacity - 0.16) / 0.42, 0, 1),
  };
};


// Clima AMBIENTAL de V2. Por seguridad no consulta ubicación, APIs externas
// ni escribe producción. En AUTO sigue un ciclo UTC estable con duración real
// y memoria visual de humedad para dejar huellas visibles tras la lluvia.
const getAutoWeatherState = () => {
  const now = new Date();
  const secondsUtc = now.getUTCHours() * 3600 + now.getUTCMinutes() * 60 + now.getUTCSeconds();
  const cycleSecond = secondsUtc % AUTO_WEATHER_TOTAL_SECONDS;
  let elapsed = 0;

  for (let index = 0; index < AUTO_WEATHER_SEQUENCE.length; index += 1) {
    const step = AUTO_WEATHER_SEQUENCE[index];
    const durationSeconds = step.minutes * 60;
    if (cycleSecond < elapsed + durationSeconds) {
      const nextStep = AUTO_WEATHER_SEQUENCE[(index + 1) % AUTO_WEATHER_SEQUENCE.length];
      const progress = (cycleSecond - elapsed) / durationSeconds;
      const wetStart = Number.isFinite(Number(step.wetStart)) ? Number(step.wetStart) : 0;
      const wetEnd = Number.isFinite(Number(step.wetEnd)) ? Number(step.wetEnd) : wetStart;
      return {
        mode: step.mode,
        wetness: clamp(wetStart + (wetEnd - wetStart) * progress, 0, 1),
        stageId: step.id,
        phaseIndex: index,
        progress,
        timeRemainingSeconds: elapsed + durationSeconds - cycleSecond,
        nextMode: nextStep.mode,
      };
    }
    elapsed += durationSeconds;
  }

  return {
    mode: 'clear',
    wetness: 0,
    stageId: 'fallback',
    phaseIndex: 0,
    progress: 0,
    timeRemainingSeconds: AUTO_WEATHER_SEQUENCE[0].minutes * 60,
    nextMode: AUTO_WEATHER_SEQUENCE[1]?.mode || 'wind',
  };
};

export function CityFarmV2({ onBack, classicEnabled = true }) {
  const { informacion, usuario } = useSelector((state) => state.userSlice);
  const viewportRef = useRef(null);
  const keysRef = useRef(new Set());
  const joystickRef = useRef({ x: 0, y: 0 });
  const playerRef = useRef(PLAYER_START);
  const walkTargetRef = useRef(null);
  const pointerDriveRef = useRef({ active: false, pointerId: null });
  const stuckFramesRef = useRef(0);
  const movementVisualRef = useRef({ moving: false, facing: 'down' });
  const lastFrameRef = useRef(null);
  const rafRef = useRef(null);
  const buildingDragRef = useRef({ active: false, pointerId: null, buildingId: null, startX: 0, startY: 0, originX: 0, originY: 0, latestX: null, latestY: null });
  const decorDragRef = useRef({ active: false, pointerId: null, decorId: null, startX: 0, startY: 0, originX: 0, originY: 0 });
  const serverLayoutHydratedRef = useRef('');
  const layoutSaveQueueRef = useRef(Promise.resolve());


  const [player, setPlayer] = useState(playerRef.current);
  const [viewport, setViewport] = useState({ width: 1200, height: 700 });
  const [zoom, setZoom] = useState(1);
  // REV34: cámara manual. Se conserva solamente en el estado de UI.
  const [panMode, setPanMode] = useState(() => typeof window !== 'undefined' && window.matchMedia?.('(pointer: coarse)').matches);
  const [cameraOffset, setCameraOffset] = useState({ x: 0, y: 0 });
  const [isPanning, setIsPanning] = useState(false);
  const panPointerRef = useRef(null);

  // Apariencia exclusivamente local: no se envía al backend ni altera el layout.
  const [premiumVisual, setPremiumVisual] = useState(() => {
    try {
      const stored = window.localStorage.getItem('cityfarm-v2-premium-visual');
      return stored !== 'off';
    } catch (_) { return true; }
  });
  const togglePremiumVisual = () => {
    setPremiumVisual((current) => {
      const next = !current;
      try { window.localStorage.setItem('cityfarm-v2-premium-visual', next ? 'on' : 'off'); }
      catch (_) {}
      return next;
    });
  };
  const [footprints, setFootprints] = useState([]);
  const footprintSeqRef = useRef(0);
  const lastFootprintAtRef = useRef(0);

  const [joystick, setJoystick] = useState({ x: 0, y: 0 });
  const [walkTarget, setWalkTarget] = useState(null);
  const [isMoving, setIsMoving] = useState(false);
  const [facing, setFacing] = useState('down');
  const [dayCycle, setDayCycle] = useState(() => getDayCycle());
  const [selectedBuildingId, setSelectedBuildingId] = useState(null);
  const [message, setMessage] = useState('Walk around the farm and get close to a building to interact.');
  const [, setShowHelp] = useState(true);
  const [activePanel, setActivePanel] = useState(null);
  const [layoutEditMode, setLayoutEditMode] = useState(false);
  const [farmLayout, setFarmLayout] = useState({});
  const [selectedRoadId, setSelectedRoadId] = useState(null);
  const [selectedFieldId, setSelectedFieldId] = useState(null);
  const [plazaSelected, setPlazaSelected] = useState(false);
  const [selectedCreativeId, setSelectedCreativeId] = useState(null);
  const [creativeCatalogOpen, setCreativeCatalogOpen] = useState(false);
  const [constructionTab, setConstructionTab] = useState('floors');
  const [layersOpen, setLayersOpen] = useState(false);
  const [layerVisibility, setLayerVisibility] = useState(DEFAULT_LAYER_VISIBILITY);
  const [whitepaperOpen, setWhitepaperOpen] = useState(false);

  const [language, setLanguage] = useState(() => {
    try {
      const saved = window.localStorage.getItem('cityfarm-v2-language-v6');
      return saved === 'es' ? 'es' : 'en';
    } catch (_) {
      return 'en';
    }
  });
  const tr = I18N[language];
  const autoWeatherState = getAutoWeatherState();
  const autoWeather = autoWeatherState.mode;
  const effectiveWeather = autoWeather;
  const groundWetness = autoWeatherState.wetness;
  const groundWet = groundWetness > 0.08;
  const weatherInfo = WEATHER_INFO[effectiveWeather] || WEATHER_INFO.clear;
  const nextWeatherInfo = WEATHER_INFO[autoWeatherState.nextMode] || WEATHER_INFO.clear;
  const animalWeatherFactor = effectiveWeather === 'storm' ? 2.5 : effectiveWeather === 'rain' ? 1.65 : 1;


  const changeLanguage = (nextLanguage) => {
    const safe = nextLanguage === 'en' ? 'en' : 'es';
    setLanguage(safe);
    try { window.localStorage.setItem('cityfarm-v2-language-v6', safe); } catch (_) {}
  };

  const setSafeZoom = useCallback((nextZoom) => {
    setZoom((current) => {
      const value = typeof nextZoom === 'function' ? nextZoom(current) : nextZoom;
      return Number(clamp(Number(value) || 1, ZOOM_MIN, ZOOM_MAX).toFixed(3));
    });
  }, []);

  const fitFarm = useCallback(() => {
    const horizontal = Math.max(0.01, (viewport.width - 22) / WORLD.width);
    const vertical = Math.max(0.01, (viewport.height - 22) / WORLD.height);
    setSafeZoom(Math.min(horizontal, vertical, 1));
  }, [viewport, setSafeZoom]);

  // REV20: encuadre inicial adaptado al espacio disponible.
  // Una sola vez por montaje: nunca sobrescribe zoom manual ni diseños guardados.
  const initialZoomAppliedRef = useRef(false);
  useEffect(() => {
    if (initialZoomAppliedRef.current || viewport.width < 300 || viewport.height < 200) return;
    initialZoomAppliedRef.current = true;
    const fillWidth = (viewport.width - 48) / ORIGINAL_WORLD.width;
    const fillHeight = (viewport.height - 48) / ORIGINAL_WORLD.height;
    setSafeZoom(Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, fillWidth, fillHeight)));
  }, [viewport.width, viewport.height, setSafeZoom]);


  const cfBalance = firstFiniteNumber(
    informacion?.cf_cf,
    informacion?.cf,
    informacion?.dinero,
    informacion?.balanceCF,
    informacion?.saldoCF
  );
  const energyBalance = getInventoryAmount(informacion, ['energia', 'energy', 'power']);
  const waterBalance = getInventoryAmount(informacion, ['agua', 'water']);
  const playerLevel = firstFiniteNumber(informacion?.nivel, informacion?.level, 1);

  const cowTelemetry = getProductionTelemetry(informacion?.tierras?.granja2, 'timed');
  const chickenTelemetry = getProductionTelemetry(informacion?.tierras?.granja1, 'timed');
  const waterTelemetry = getProductionTelemetry(informacion?.tierras?.agua, 'continuous');
  const energyTelemetry = getProductionTelemetry(informacion?.tierras?.energia, 'continuous');
  const restPhase = isRestPhase(dayCycle.phase);

  // El estado del molino solo se usa si YA viene en Redux. No hacemos polling ni
  // nuevas llamadas al backend para una animación.
  const millActivitySignals = [
    informacion?.molinoActivo,
    informacion?.molinoProcesando,
    informacion?.molino?.activo,
    informacion?.molino?.procesando,
    informacion?.molino?.working,
    informacion?.mill?.active,
    informacion?.mill?.working,
    Array.isArray(informacion?.procesosMolino) ? informacion.procesosMolino.length : 0,
    Array.isArray(informacion?.activosMolino) ? informacion.activosMolino.length : 0,
  ];
  const millActive = millActivitySignals.some((value) =>
    value === true || (typeof value === 'number' && value > 0) || String(value).toLowerCase() === 'true'
  );

  const readyProductionCount = [
    ...['trigo', 'trigo2', 'maiz', 'maiz2', 'arbol', 'arbol2', 'arbol3', 'granja1', 'granja2']
      .map((key) => getProductionTelemetry(informacion?.tierras?.[key], 'timed')),
    waterTelemetry,
    energyTelemetry,
  ].filter((telemetry) => telemetry?.status === 'ready').length;


  // En el backend actual informacion.nombre es la cuenta Hive cuando está
  // asociada. Los usuarios creados por email pueden traer @null-xxxx; eso no
  // es una cuenta Hive y no debe mostrarse como si lo fuera.
  const rawHiveUser = String(
    informacion?.hiveUser ||
    informacion?.hiveUsername ||
    informacion?.hiveAccount ||
    informacion?.cuentaHive ||
    informacion?.nombre ||
    usuario?.user ||
    usuario?.username ||
    ''
  ).trim();
  const normalizedHiveUser = rawHiveUser.replace(/^@+/, '');
  const hiveConnected = Boolean(
    normalizedHiveUser &&
    !normalizedHiveUser.toLowerCase().startsWith('null-') &&
    !normalizedHiveUser.toLowerCase().startsWith('null_') &&
    normalizedHiveUser.toLowerCase() !== 'null'
  );
  const hiveDisplay = hiveConnected ? `@${normalizedHiveUser}` : tr.hiveMissing;
  const playerName = hiveConnected ? `@${normalizedHiveUser}` : 'Farmer';

  // Distribución cosmética por cuenta y navegador. No altera coordenadas del backend.
  const layoutOwner = String(
    normalizedHiveUser ||
    informacion?._id ||
    informacion?.id ||
    usuario?._id ||
    usuario?.id ||
    usuario?.username ||
    'guest'
  ).replace(/[^a-zA-Z0-9_.-]/g, '_').slice(0, 80);
  const layoutStorageKey = `cityfarm-v2-layout-v2:${layoutOwner}`;
  const layerStorageKey = `cityfarm-v2-layers-v1:${layoutOwner}`;

  const layoutSyncRef = useRef({ owner: null, loaded: false, version: null, conflict: false });
  const [layoutSaveStatus, setLayoutSaveStatus] = useState('loading');
  useEffect(() => {
    let cancelled = false;
    const sync = async () => {
      layoutSyncRef.current = { owner: layoutOwner, loaded: false, version: null, conflict: false };
      setLayoutSaveStatus('loading');
      const token = getCookie('token');
      if (!token || layoutOwner === 'guest') {
        setLayoutSaveStatus('offline');
        return;
      }
      try {
        const { data } = await axios.get(rutas.cityFarmV2Layout, { headers: { token } });
        if (cancelled) return;
        const serverLayout = migrateLegacyWorldLayout(data?.layout && typeof data.layout === 'object' ? data.layout : {});
        // MongoDB es la fuente oficial; nunca mezclar con datos viejos del navegador.
        setFarmLayout(serverLayout);
        layoutSyncRef.current = { owner: layoutOwner, loaded: true, version: data?.updatedAt || null, conflict: false };
        setLayoutSaveStatus('saved');
        try {
          const old = window.localStorage.getItem(layoutStorageKey);
          if (old && old !== JSON.stringify(serverLayout)) window.localStorage.setItem(`${layoutStorageKey}:backup-before-server`, old);
          window.localStorage.setItem(layoutStorageKey, JSON.stringify(serverLayout));
        } catch (_) {}
      } catch (error) {
        if (cancelled) return;
        // No permitir que un diseño local viejo sobrescriba MongoDB al volver la red.
        setLayoutSaveStatus('offline');
        console.warn('[CityFarm] No se pudo obtener el layout oficial:', error);
      }
    };
    sync();
    return () => { cancelled = true; };
  }, [layoutOwner, layoutStorageKey]);

  useEffect(() => {
    try {
      const raw = window.localStorage.getItem(layerStorageKey);
      const parsed = raw ? JSON.parse(raw) : {};
      setLayerVisibility({ ...DEFAULT_LAYER_VISIBILITY, ...(parsed && typeof parsed === 'object' ? parsed : {}) });
    } catch (_) {
      setLayerVisibility(DEFAULT_LAYER_VISIBILITY);
    }
  }, [layerStorageKey]);

  const placedBuildings = useMemo(() => BUILDINGS.map((building) => {
    const saved = farmLayout?.[building.id];
    const baseX = building.x + MAP_SHIFT.x;
    const baseY = building.y + MAP_SHIFT.y;
    if (!saved || !Number.isFinite(Number(saved.x)) || !Number.isFinite(Number(saved.y))) {
      return {
        ...building,
        x: baseX,
        y: baseY,
        collider: {
          ...building.collider,
          x: building.collider.x + MAP_SHIFT.x,
          y: building.collider.y + MAP_SHIFT.y,
        },
      };
    }
    const x = clamp(Number(saved.x), 0, WORLD.width - building.width);
    const y = clamp(Number(saved.y), 0, WORLD.height - 220);
    const dx = x - baseX;
    const dy = y - baseY;
    return {
      ...building,
      x,
      y,
      collider: {
        ...building.collider,
        x: building.collider.x + MAP_SHIFT.x + dx,
        y: building.collider.y + MAP_SHIFT.y + dy,
      },
    };
  }), [farmLayout]);

  const placedTrees = useMemo(() => TREE_DECOR.map((item) => {
    const saved = farmLayout?.[item.id];
    const baseX = item.x + MAP_SHIFT.x;
    const baseY = item.y + MAP_SHIFT.y;
    return {
      ...item,
      x: Number.isFinite(Number(saved?.x)) ? clamp(Number(saved.x), 0, WORLD.width - item.width) : baseX,
      y: Number.isFinite(Number(saved?.y)) ? clamp(Number(saved.y), 0, WORLD.height - item.height) : baseY,
      visible: saved?.visible !== false,
    };
  }), [farmLayout]);

  const placedLamps = useMemo(() => LAMP_DECOR.map((item) => {
    const saved = farmLayout?.[item.id];
    const baseX = item.x + MAP_SHIFT.x;
    const baseY = item.y + MAP_SHIFT.y;
    return {
      ...item,
      x: Number.isFinite(Number(saved?.x)) ? clamp(Number(saved.x), 0, WORLD.width - item.width) : baseX,
      y: Number.isFinite(Number(saved?.y)) ? clamp(Number(saved.y), 0, WORLD.height - item.height) : baseY,
    };
  }), [farmLayout]);


  const placedLake = useMemo(() => {
    const saved = farmLayout?.[LAKE_DECOR.id];
    const baseX = LAKE_DECOR.x;
    const baseY = LAKE_DECOR.y;
    return {
      ...LAKE_DECOR,
      x: Number.isFinite(Number(saved?.x)) ? clamp(Number(saved.x), 0, WORLD.width - LAKE_DECOR.width) : baseX,
      y: Number.isFinite(Number(saved?.y)) ? clamp(Number(saved.y), 0, WORLD.height - LAKE_DECOR.height) : baseY,
    };
  }, [farmLayout]);


  const placedRiver = useMemo(() => {
    const saved = farmLayout?.[RIVER_DECOR.id];
    return {
      ...RIVER_DECOR,
      x: Number.isFinite(Number(saved?.x)) ? clamp(Number(saved.x), RIVER_DECOR.minX, RIVER_DECOR.maxX) : RIVER_DECOR.x,
      y: Number.isFinite(Number(saved?.y)) ? clamp(Number(saved.y), RIVER_DECOR.minY, RIVER_DECOR.maxY) : RIVER_DECOR.y,
    };
  }, [farmLayout]);


  const placedRoads = useMemo(() => [
    ...ROAD_PIECES,
    ...Object.entries(farmLayout || {})
      .filter(([id, item]) => /^road-custom-\d{2,4}$/.test(id) && item && typeof item === 'object')
      .map(([id, item]) => ({ id, kind: 'straight', x: item.x || 0, y: item.y || 0, rotation: 0 }))
  ].map((road) => {
    const saved = farmLayout?.[road.id] || {};
    const savedKind = ROAD_TYPES.includes(saved?.kind) ? saved.kind : road.kind;
    const rawRotation = Number.isFinite(Number(saved?.rotation)) ? Number(saved.rotation) : road.rotation;
    const safeRotation = ((Math.round(rawRotation / 90) * 90) % 360 + 360) % 360;
    return {
      ...road,
      editorType: 'road',
      width: ROAD_TILE_SIZE,
      height: ROAD_TILE_SIZE,
      x: Number.isFinite(Number(saved?.x)) ? clamp(Number(saved.x), 0, WORLD.width - ROAD_TILE_SIZE) : road.x,
      y: Number.isFinite(Number(saved?.y)) ? clamp(Number(saved.y), 0, WORLD.height - ROAD_TILE_SIZE) : road.y,
      rotation: safeRotation,
      kind: savedKind,
      visible: saved?.visible !== false,
      replacement: ROAD_REPLACEMENTS.includes(saved?.replacement) ? saved.replacement : 'none',
      snap: 20,
    };
  }), [farmLayout]);

  const placedSimpleFields = useMemo(() => SIMPLE_FIELDS.map((field) => {
    const saved = farmLayout?.[field.id] || {};
    return {
      ...field,
      editorType: 'simple-field',
      x: Number.isFinite(Number(saved?.x)) ? clamp(Number(saved.x), 0, WORLD.width - field.width) : field.x,
      y: Number.isFinite(Number(saved?.y)) ? clamp(Number(saved.y), 0, WORLD.height - field.height) : field.y,
      visible: saved?.visible !== false,
      variant: Number.isFinite(Number(saved?.variant)) ? clamp(Math.round(Number(saved.variant)), 0, 2) : field.variant,
      snap: 20,
    };
  }), [farmLayout]);

  const placedPlaza = useMemo(() => {
    const saved = farmLayout?.[PLAZA_DECOR.id] || {};
    return {
      ...PLAZA_DECOR,
      editorType: 'plaza',
      x: Number.isFinite(Number(saved?.x)) ? clamp(Number(saved.x), 0, WORLD.width - PLAZA_DECOR.width) : PLAZA_DECOR.x,
      y: Number.isFinite(Number(saved?.y)) ? clamp(Number(saved.y), 0, WORLD.height - PLAZA_DECOR.height) : PLAZA_DECOR.y,
      visible: saved?.visible !== false,
      style: PLAZA_STYLES.includes(saved?.style) ? saved.style : 'stone',
      accessories: Array.isArray(saved?.accessories) ? saved.accessories.filter((item) => PLAZA_ACCESSORIES.includes(item)).slice(0, 6) : [],
      snap: 20,
    };
  }, [farmLayout]);

  const [selectedTreeId, setSelectedTreeId] = useState(null);
  const selectedTree = placedTrees.find((tree) => tree.id === selectedTreeId) || null;

  const selectedRoad = useMemo(
    () => placedRoads.find((road) => road.id === selectedRoadId) || null,
    [placedRoads, selectedRoadId]
  );

  const selectedSimpleField = useMemo(
    () => placedSimpleFields.find((field) => field.id === selectedFieldId) || null,
    [placedSimpleFields, selectedFieldId]
  );

  const placedCreativeDecor = useMemo(() => {
    const items = [];
    for (let index = 1; index <= MAX_CREATIVE_DECOR; index += 1) {
      const id = `creative-decor-${String(index).padStart(2, '0')}`;
      const saved = farmLayout?.[id];
      if (!saved || typeof saved !== 'object') continue;
      const type = CREATIVE_DECOR_TYPES.includes(saved.type) ? saved.type : 'lamp';
      const rotation = ((Math.round((Number(saved.rotation) || 0) / 90) * 90) % 360 + 360) % 360;
      items.push({
        id,
        type,
        editorType: 'creative-decor',
        width: getDecorSize(type),
        height: getDecorSize(type),
        x: clamp(Number(saved.x) || PLAYER_START.x, 0, WORLD.width - getDecorSize(type)),
        y: clamp(Number(saved.y) || PLAYER_START.y, 0, WORLD.height - getDecorSize(type)),
        rotation,
        visible: saved.visible !== false,
        snap: 20,
      });
    }
    return items;
  }, [farmLayout]);

  const selectedCreativeDecor = useMemo(
    () => placedCreativeDecor.find((item) => item.id === selectedCreativeId) || null,
    [placedCreativeDecor, selectedCreativeId]
  );


  const roadsCustomized = useMemo(
    () => ROAD_PIECES.some((road) => Boolean(farmLayout?.[road.id])),
    [farmLayout]
  );

  const saveFarmLayout = useCallback((nextLayout) => {
    try {
      const previous = window.localStorage.getItem(layoutStorageKey);
      if (previous && previous !== JSON.stringify(nextLayout)) {
        const before = JSON.parse(previous);
        const oldPieces = Object.keys(before || {}).filter((key) => key.startsWith('creative-decor-'));
        const newPieces = Object.keys(nextLayout || {}).filter((key) => key.startsWith('creative-decor-'));
        // Guardar una instantánea cuando un guardado borraría piezas creadas.
        if (oldPieces.some((key) => !newPieces.includes(key)) ||
            Object.keys(before || {}).some((key) => !(key in (nextLayout || {})))) {
          window.localStorage.setItem(`${layoutStorageKey}:backup-pieces-protected`, previous);
          console.warn('[CityFarm] Respaldo creado: un diseño nuevo omitía piezas existentes.');
        }
      }
      window.localStorage.setItem(layoutStorageKey, JSON.stringify(nextLayout));
    } catch (error) {
      console.warn('[CityFarm] No se pudo guardar copia local del diseño:', error);
    }

    const token = getCookie('token');
    if (!token || layoutOwner === 'guest' || !layoutSyncRef.current.loaded || layoutSyncRef.current.conflict) {
      setLayoutSaveStatus(layoutSyncRef.current.conflict ? 'conflict' : 'offline');
      return;
    }
    setLayoutSaveStatus('saving');
    layoutSaveQueueRef.current = layoutSaveQueueRef.current.then(async () => {
      const sync = layoutSyncRef.current;
      if (!sync.loaded || sync.conflict || sync.owner !== layoutOwner) return;
      try {
        const { data } = await axios.put(rutas.cityFarmV2Layout,
          { layout: nextLayout, expectedUpdatedAt: sync.version }, { headers: { token } });
        sync.version = data?.updatedAt || null;
        setLayoutSaveStatus('saved');
      } catch (error) {
        if (error?.response?.status === 409) {
          sync.conflict = true;
          setLayoutSaveStatus('conflict');
        } else setLayoutSaveStatus('offline');
        console.warn('[CityFarm] Guardado no confirmado por MongoDB:', error);
      }
    }).catch((error) => console.warn('[CityFarm] Error en cola de guardado:', error));
  }, [layoutOwner, layoutStorageKey]);


  // Los jardines se agregan desde la biblioteca, por decisión del usuario.
  // No autogenerar ni guardar diseños durante la carga del servidor:
  // un guardado prematuro podría reemplazar piezas existentes.

  const setObjectVisibility = useCallback((id, visible) => {
    setFarmLayout((current) => {
      const next = { ...current, [id]: { ...(current?.[id] || {}), visible } };
      saveFarmLayout(next);
      return next;
    });
  }, [saveFarmLayout]);

  const restoreHiddenObjects = useMemo(() => [
    ...placedRoads.filter((item) => !item.visible).map((item) => ({ id: item.id, label: `🛣️ ${item.id}` })),
    ...placedTrees.filter((item) => !item.visible).map((item) => ({ id: item.id, label: `🌳 ${item.id}` })),
    ...placedSimpleFields.filter((item) => !item.visible).map((item) => ({ id: item.id, label: `🌾 ${item.id}` })),
    ...placedCreativeDecor.filter((item) => !item.visible).map((item) => ({ id: item.id, label: `✨ ${CREATIVE_DECOR_LABELS[item.type]?.es || item.type}` })),
    ...(!placedPlaza.visible ? [{ id: placedPlaza.id, label: '🏛️ Plaza' }] : []),
  ], [placedRoads, placedTrees, placedSimpleFields, placedCreativeDecor, placedPlaza]);

  const updateSelectedRoad = useCallback((patch) => {
    if (!selectedRoad) return;
    setFarmLayout((current) => {
      const currentEntry = current?.[selectedRoad.id] || {};
      const next = {
        ...current,
        [selectedRoad.id]: {
          ...currentEntry,
          x: Number.isFinite(Number(currentEntry.x)) ? Number(currentEntry.x) : selectedRoad.x,
          y: Number.isFinite(Number(currentEntry.y)) ? Number(currentEntry.y) : selectedRoad.y,
          kind: ROAD_TYPES.includes(patch?.kind) ? patch.kind : (ROAD_TYPES.includes(currentEntry.kind) ? currentEntry.kind : selectedRoad.kind),
          rotation: Number.isFinite(Number(patch?.rotation)) ? Number(patch.rotation) : selectedRoad.rotation,
          visible: typeof patch?.visible === 'boolean' ? patch.visible : (currentEntry.visible !== false),
          replacement: ROAD_REPLACEMENTS.includes(patch?.replacement) ? patch.replacement : (ROAD_REPLACEMENTS.includes(currentEntry.replacement) ? currentEntry.replacement : selectedRoad.replacement),
        },
      };
      saveFarmLayout(next);
      return next;
    });
  }, [saveFarmLayout, selectedRoad]);

  const rotateSelectedRoad = useCallback(() => {
    if (!selectedRoad) return;
    updateSelectedRoad({ rotation: (selectedRoad.rotation + 90) % 360 });
  }, [selectedRoad, updateSelectedRoad]);

  const cycleSelectedRoadType = useCallback(() => {
    if (!selectedRoad) return;
    const index = Math.max(0, ROAD_TYPES.indexOf(selectedRoad.kind));
    updateSelectedRoad({ kind: ROAD_TYPES[(index + 1) % ROAD_TYPES.length] });
  }, [selectedRoad, updateSelectedRoad]);

  const updateSelectedField = useCallback((patch) => {
    if (!selectedSimpleField) return;
    setFarmLayout((current) => {
      const entry = current?.[selectedSimpleField.id] || {};
      const next = {
        ...current,
        [selectedSimpleField.id]: {
          ...entry,
          x: Number.isFinite(Number(entry.x)) ? Number(entry.x) : selectedSimpleField.x,
          y: Number.isFinite(Number(entry.y)) ? Number(entry.y) : selectedSimpleField.y,
          visible: typeof patch?.visible === 'boolean' ? patch.visible : (entry.visible !== false),
          variant: Number.isFinite(Number(patch?.variant)) ? clamp(Math.round(Number(patch.variant)), 0, 2) : selectedSimpleField.variant,
        },
      };
      saveFarmLayout(next);
      return next;
    });
  }, [saveFarmLayout, selectedSimpleField]);

  const updatePlaza = useCallback((patch) => {
    setFarmLayout((current) => {
      const entry = current?.[PLAZA_DECOR.id] || {};
      const currentAccessories = Array.isArray(entry.accessories) ? entry.accessories : placedPlaza.accessories;
      const next = {
        ...current,
        [PLAZA_DECOR.id]: {
          ...entry,
          x: Number.isFinite(Number(entry.x)) ? Number(entry.x) : placedPlaza.x,
          y: Number.isFinite(Number(entry.y)) ? Number(entry.y) : placedPlaza.y,
          visible: typeof patch?.visible === 'boolean' ? patch.visible : (entry.visible !== false),
          style: PLAZA_STYLES.includes(patch?.style) ? patch.style : (PLAZA_STYLES.includes(entry.style) ? entry.style : placedPlaza.style),
          accessories: Array.isArray(patch?.accessories) ? patch.accessories.filter((item) => PLAZA_ACCESSORIES.includes(item)).slice(0, 6) : currentAccessories,
        },
      };
      saveFarmLayout(next);
      return next;
    });
  }, [placedPlaza, saveFarmLayout]);

  const togglePlazaAccessory = useCallback((accessory) => {
    if (!PLAZA_ACCESSORIES.includes(accessory)) return;
    const current = placedPlaza.accessories || [];
    const nextAccessories = current.includes(accessory)
      ? current.filter((item) => item !== accessory)
      : [...current, accessory].slice(0, 6);
    updatePlaza({ accessories: nextAccessories });
  }, [placedPlaza.accessories, updatePlaza]);

  const addRoadPiece = useCallback((kind) => {
    if (!ROAD_TYPES.includes(kind)) return;
    setFarmLayout((current) => {
      let id = null;
      for (let i = 1; i <= 150; i += 1) {
        const candidate = `road-custom-${String(i).padStart(3, '0')}`;
        if (!current?.[candidate]) { id = candidate; break; }
      }
      if (!id) return current;
      const x = Math.round(clamp(playerRef.current.x + 120, 0, WORLD.width - ROAD_TILE_SIZE) / 20) * 20;
      const y = Math.round(clamp(playerRef.current.y + 100, 0, WORLD.height - ROAD_TILE_SIZE) / 20) * 20;
      const next = { ...current, [id]: { x, y, kind, rotation: 0, visible: true, replacement: 'none' } };
      saveFarmLayout(next);
      setSelectedRoadId(id);
      return next;
    });
    setCreativeCatalogOpen(false);
  }, [saveFarmLayout]);

  const addCreativeDecoration = useCallback((type) => {
    if (!CREATIVE_DECOR_TYPES.includes(type)) return;
    let slotId = null;
    for (let index = 1; index <= MAX_CREATIVE_DECOR; index += 1) {
      const candidate = `creative-decor-${String(index).padStart(2, '0')}`;
      if (!farmLayout?.[candidate] || farmLayout[candidate]?.visible === false) {
        slotId = candidate;
        break;
      }
    }
    if (!slotId) return;
    const size = getDecorSize(type);
    const x = Math.round(clamp(playerRef.current.x + 80, 20, WORLD.width - size) / 16) * 16;
    const y = Math.round(clamp(playerRef.current.y + 40, 90, WORLD.height - size) / 16) * 16;
    setFarmLayout((current) => {
      const next = { ...current, [slotId]: { x, y, type, rotation: 0, visible: true } };
      saveFarmLayout(next);
      return next;
    });
    setSelectedCreativeId(slotId);
    setCreativeCatalogOpen(false);
  }, [farmLayout, saveFarmLayout]);

  const updateSelectedCreative = useCallback((patch) => {
    if (!selectedCreativeDecor) return;
    setFarmLayout((current) => {
      const entry = current?.[selectedCreativeDecor.id] || {};
      const next = {
        ...current,
        [selectedCreativeDecor.id]: {
          ...entry,
          x: Number.isFinite(Number(entry.x)) ? Number(entry.x) : selectedCreativeDecor.x,
          y: Number.isFinite(Number(entry.y)) ? Number(entry.y) : selectedCreativeDecor.y,
          type: CREATIVE_DECOR_TYPES.includes(patch?.type) ? patch.type : (CREATIVE_DECOR_TYPES.includes(entry.type) ? entry.type : selectedCreativeDecor.type),
          rotation: Number.isFinite(Number(patch?.rotation)) ? Number(patch.rotation) : selectedCreativeDecor.rotation,
          visible: typeof patch?.visible === 'boolean' ? patch.visible : (entry.visible !== false),
        },
      };
      saveFarmLayout(next);
      return next;
    });
  }, [saveFarmLayout, selectedCreativeDecor]);

  const saveLayerVisibility = useCallback((nextLayers) => {
    try {
      window.localStorage.setItem(layerStorageKey, JSON.stringify(nextLayers));
    } catch (_) {}
  }, [layerStorageKey]);

  const toggleLayerVisibility = useCallback((layerId) => {
    setLayerVisibility((current) => {
      const next = { ...current, [layerId]: !current[layerId] };
      saveLayerVisibility(next);
      return next;
    });
  }, [saveLayerVisibility]);

  const resetLayerVisibility = useCallback(() => {
    setLayerVisibility(DEFAULT_LAYER_VISIBILITY);
    saveLayerVisibility(DEFAULT_LAYER_VISIBILITY);
    setMessage(tr.layersSaved);
  }, [saveLayerVisibility, tr.layersSaved]);

  const resetFarmLayout = () => {
    setSelectedRoadId(null);
    setSelectedFieldId(null);
    setPlazaSelected(false);
    setSelectedCreativeId(null);
    setFarmLayout({});
    try { window.localStorage.removeItem(layoutStorageKey); } catch (_) {}
    saveFarmLayout({});
    setMessage(tr.layoutSaved);
  };

  const finishArrange = () => {
    setLayoutEditMode(false);
    setSelectedRoadId(null);
    setSelectedFieldId(null);
    setPlazaSelected(false);
    setSelectedCreativeId(null);
    setCreativeCatalogOpen(false);
    saveFarmLayout(farmLayout);
    // Evita que el avatar quede atrapado debajo de un edificio recién movido.
    const safe = PLAYER_START;
    playerRef.current = safe;
    setPlayer(safe);
    walkTargetRef.current = null;
    setWalkTarget(null);
    setMessage(tr.layoutSaved);
  };

  const startBuildingDrag = (event, building) => {
    if (!layoutEditMode) return;
    event.preventDefault();
    event.stopPropagation();
    buildingDragRef.current = {
      active: true,
      pointerId: event.pointerId,
      buildingId: building.id,
      startX: event.clientX,
      startY: event.clientY,
      originX: building.x,
      originY: building.y,
      latestX: building.x,
      latestY: building.y,
      maxX: WORLD.width - building.width,
      maxY: WORLD.height - 220,
    };
    event.currentTarget.setPointerCapture?.(event.pointerId);
  };

  const moveBuildingDrag = (event, building) => {
    const drag = buildingDragRef.current;
    if (!layoutEditMode || !drag.active || drag.pointerId !== event.pointerId || drag.buildingId !== building.id) return;
    event.preventDefault();
    event.stopPropagation();
    const dx = (event.clientX - drag.startX) / Math.max(.16, zoom);
    const dy = (event.clientY - drag.startY) / Math.max(.16, zoom);
    // Movimiento libre durante el arrastre; el snap ocurre SIEMPRE al soltar.
    const nextX = Math.round(clamp(drag.originX + dx, 0, WORLD.width - building.width));
    const nextY = Math.round(clamp(drag.originY + dy, 0, WORLD.height - 220));
    drag.latestX = nextX;
    drag.latestY = nextY;
    setFarmLayout((current) => {
      const next = {
        ...current,
        [building.id]: { ...(current?.[building.id] || {}), x: nextX, y: nextY },
      };
      // Respaldo local inmediato: si el pointerup se pierde o la pestaña
      // se cierra durante el arrastre, la última posición visible no se pierde.
      try { window.localStorage.setItem(layoutStorageKey, JSON.stringify(next)); } catch (_) {}
      return next;
    });
  };

  const stopBuildingDrag = (event) => {
    const drag = buildingDragRef.current;
    if (!drag.active || drag.pointerId !== event.pointerId) return;
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.releasePointerCapture?.(event.pointerId);
    const rawX = Number.isFinite(Number(drag.latestX)) ? Number(drag.latestX) : drag.originX;
    const rawY = Number.isFinite(Number(drag.latestY)) ? Number(drag.latestY) : drag.originY;
    const movedBuildingId = drag.buildingId;
    const movingBuilding = placedBuildings.find((building) => building.id === movedBuildingId);
    const peerBuildings = placedBuildings.filter((building) => building.id !== movedBuildingId);
    const snapped = getProfessionalReleaseSnap({
      rawX,
      rawY,
      maxX: Number(drag.maxX) || WORLD.width,
      maxY: Number(drag.maxY) || WORLD.height,
      itemWidth: firstFiniteNumber(movingBuilding?.width, 0),
      candidates: peerBuildings,
    });
    const finalX = snapped.x;
    const finalY = snapped.y;
    buildingDragRef.current = { active: false, pointerId: null, buildingId: null, startX: 0, startY: 0, originX: 0, originY: 0, latestX: null, latestY: null, maxX: 0, maxY: 0 };
    setFarmLayout((current) => {
      const next = {
        ...current,
        [movedBuildingId]: { ...(current?.[movedBuildingId] || {}), x: finalX, y: finalY },
      };
      saveFarmLayout(next);
      return next;
    });
  };

  const startDecorDrag = (event, decor) => {
    if (!layoutEditMode) return;
    event.preventDefault();
    event.stopPropagation();
    decorDragRef.current = {
      active: true,
      pointerId: event.pointerId,
      decorId: decor.id,
      startX: event.clientX,
      startY: event.clientY,
      originX: decor.x,
      originY: decor.y,
      latestX: decor.x,
      latestY: decor.y,
      minX: Number.isFinite(Number(decor.minX)) ? Number(decor.minX) : 0,
      maxX: Number.isFinite(Number(decor.maxX)) ? Number(decor.maxX) : WORLD.width - decor.width,
      minY: Number.isFinite(Number(decor.minY)) ? Number(decor.minY) : 0,
      maxY: Number.isFinite(Number(decor.maxY)) ? Number(decor.maxY) : WORLD.height - decor.height,
      width: Math.max(0, Number(decor.width) || 0),
      height: Math.max(0, Number(decor.height) || 0),
      snap: Math.max(ARRANGE_GRID_SIZE, Number(decor?.snap) || ARRANGE_GRID_SIZE),
      editorType: decor?.editorType || null,
    };
    event.currentTarget.setPointerCapture?.(event.pointerId);
  };

  const moveDecorDrag = (event, decor) => {
    const drag = decorDragRef.current;
    if (!layoutEditMode || !drag.active || drag.pointerId !== event.pointerId || drag.decorId !== decor.id) return;
    event.preventDefault();
    event.stopPropagation();
    const dx = (event.clientX - drag.startX) / Math.max(.16, zoom);
    const dy = (event.clientY - drag.startY) / Math.max(.16, zoom);
    const minX = Number.isFinite(Number(decor.minX)) ? Number(decor.minX) : 0;
    const maxX = Number.isFinite(Number(decor.maxX)) ? Number(decor.maxX) : WORLD.width - decor.width;
    const minY = Number.isFinite(Number(decor.minY)) ? Number(decor.minY) : 0;
    const maxY = Number.isFinite(Number(decor.maxY)) ? Number(decor.maxY) : WORLD.height - decor.height;
    // Movimiento libre mientras se arrastra. La alineación se fuerza al soltar.
    const nextX = Math.round(clamp(drag.originX + dx, minX, maxX));
    const nextY = Math.round(clamp(drag.originY + dy, minY, maxY));
    drag.latestX = nextX;
    drag.latestY = nextY;

    setFarmLayout((current) => ({
      ...current,
      [decor.id]: { ...(current?.[decor.id] || {}), x: nextX, y: nextY },
    }));
  };

  const stopDecorDrag = (event) => {
    const drag = decorDragRef.current;
    if (!drag.active || drag.pointerId !== event.pointerId) return;
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.releasePointerCapture?.(event.pointerId);
    const snap = Math.max(ARRANGE_GRID_SIZE, Number(drag.snap) || ARRANGE_GRID_SIZE);
    const rawX = Number.isFinite(Number(drag.latestX)) ? Number(drag.latestX) : drag.originX;
    const rawY = Number.isFinite(Number(drag.latestY)) ? Number(drag.latestY) : drag.originY;

    const isGroundTile = drag.editorType === 'creative-decor' &&
      String(farmLayout?.[drag.decorId]?.type || '').startsWith('ground-');

    const isGroundAnchoredPiece = !isGroundTile && (
      String(drag.decorId || '').startsWith('tree-decor-')
      || String(drag.decorId || '').startsWith('lamp-decor-')
      || String(drag.decorId || '').startsWith('creative-decor-'));

    let finalX;
    let finalY;

    if (isGroundTile) {
      // Los pisos son superficies: pueden compartir espacio con árboles/casas.
      // Como cada loseta mide 128x128, la cuadrícula de 16 permite unirlas
      // exactamente sin los huecos que generaba el paso anterior de 20.
      const tileGrid = 16;
      finalX = clamp(Math.round(rawX / tileGrid) * tileGrid, drag.minX, Math.floor(drag.maxX / tileGrid) * tileGrid);
      finalY = clamp(Math.round(rawY / tileGrid) * tileGrid, drag.minY, Math.floor(drag.maxY / tileGrid) * tileGrid);
      const tilePeers = placedCreativeDecor.filter((item) =>
        item.id !== drag.decorId && item.visible && item.type.startsWith('ground-'));
      const magneticThreshold = 64;
      let nearest = null;
      for (const peer of tilePeers) {
        const candidates = [
          [peer.x + peer.width, peer.y], [peer.x - drag.width, peer.y],
          [peer.x, peer.y + peer.height], [peer.x, peer.y - drag.height],
        ];
        for (const [candidateX, candidateY] of candidates) {
          const distance = Math.hypot(rawX - candidateX, rawY - candidateY);
          if (distance <= magneticThreshold && (!nearest || distance < nearest.distance)) {
            nearest = { x: candidateX, y: candidateY, distance };
          }
        }
      }
      if (nearest) {
        finalX = clamp(nearest.x, drag.minX, drag.maxX);
        finalY = clamp(nearest.y, drag.minY, drag.maxY);
      }
    } else if (isGroundAnchoredPiece) {
      const snapped = snapDecorAnchorToGrid({
        rawX,
        rawY,
        width: drag.width,
        height: drag.height,
        minX: drag.minX,
        maxX: drag.maxX,
        minY: drag.minY,
        maxY: drag.maxY,
        step: ARRANGE_GRID_SIZE,
      });

      const occupied = [
        ...placedTrees,
        ...placedLamps,
        ...placedCreativeDecor,
      ]
        .filter((item) => item.id !== drag.decorId)
        .map((item) => getArrangeSlotRect(item));

      const freeSpot = findNearestFreeDecorGridSpot({
        x: snapped.x,
        y: snapped.y,
        width: drag.width,
        height: drag.height,
        minX: drag.minX,
        maxX: drag.maxX,
        minY: drag.minY,
        maxY: drag.maxY,
        occupied,
        step: ARRANGE_GRID_SIZE,
      });
      finalX = freeSpot.x;
      finalY = freeSpot.y;
    } else {
      const snappedMaxX = Math.floor(drag.maxX / snap) * snap;
      const snappedMaxY = Math.floor(drag.maxY / snap) * snap;
      finalX = clamp(Math.round(rawX / snap) * snap, drag.minX, snappedMaxX);
      finalY = clamp(Math.round(rawY / snap) * snap, drag.minY, snappedMaxY);
    }

    if (drag.editorType === 'road') {
      const magneticThreshold = 34;
      const peers = placedRoads.filter((road) => road.id !== drag.decorId);
      for (const peer of peers) {
        if (Math.abs(finalX - peer.x) <= magneticThreshold) finalX = peer.x;
        if (Math.abs(finalY - peer.y) <= magneticThreshold) finalY = peer.y;
      }
      finalX = Math.round(finalX / ARRANGE_GRID_SIZE) * ARRANGE_GRID_SIZE;
      finalY = Math.round(finalY / ARRANGE_GRID_SIZE) * ARRANGE_GRID_SIZE;
    }

    const movedDecorId = drag.decorId;
    decorDragRef.current = { active: false, pointerId: null, decorId: null, startX: 0, startY: 0, originX: 0, originY: 0, latestX: null, latestY: null, width: 0, height: 0 };
    setFarmLayout((current) => {
      const next = {
        ...current,
        [movedDecorId]: { ...(current?.[movedDecorId] || {}), x: finalX, y: finalY },
      };
      saveFarmLayout(next);
      return next;
    });
  };

  const canStandAt = useCallback((x, y) => {
    // Colisión circular centrada en los pies, no en todo el sprite.
    const radius = 17;
    const footY = y + 12;
    if (x - radius < 35 || footY - radius < 70 || x + radius > WORLD.width - 35 || footY + radius > WORLD.height - 35) {
      return false;
    }
    return !placedBuildings.some((building) => {
      const rect = building.collider;
      const nearestX = clamp(x, rect.x, rect.x + rect.w);
      const nearestY = clamp(footY, rect.y, rect.y + rect.h);
      const deltaX = x - nearestX;
      const deltaY = footY - nearestY;
      return deltaX * deltaX + deltaY * deltaY < radius * radius;
    });
  }, [placedBuildings]);

  const movePlayer = useCallback((dx, dy) => {
    // Subpasos para evitar atravesar obstáculos a gran velocidad y para
    // deslizarse suavemente por los bordes usando la colisión circular.
    const current = playerRef.current;
    const steps = Math.max(1, Math.ceil(Math.max(Math.abs(dx), Math.abs(dy)) / 5));
    const stepX = dx / steps;
    const stepY = dy / steps;
    let nextX = current.x;
    let nextY = current.y;
    for (let index = 0; index < steps; index += 1) {
      const targetX = clamp(nextX + stepX, 45, WORLD.width - 45);
      const targetY = clamp(nextY + stepY, 80, WORLD.height - 45);
      if (canStandAt(targetX, targetY)) {
        nextX = targetX;
        nextY = targetY;
      } else {
        // Deslizar por cualquiera de los ejes libres sin empujar al jugador.
        if (canStandAt(targetX, nextY)) nextX = targetX;
        if (canStandAt(nextX, targetY)) nextY = targetY;
      }
    }
    if (Math.abs(nextX - current.x) + Math.abs(nextY - current.y) > 0.001) {
      const next = { x: nextX, y: nextY };
      playerRef.current = next;
      setPlayer(next);
      setShowHelp(false);
      return true;
    }
    return false;
  }, [canStandAt]);

  useEffect(() => {
    const node = viewportRef.current;
    if (!node) return undefined;

    const updateSize = () => {
      const rect = node.getBoundingClientRect();
      setViewport({ width: rect.width, height: rect.height });
    };

    updateSize();
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(updateSize) : null;
    observer?.observe(node);
    window.addEventListener('resize', updateSize);

    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', updateSize);
    };
  }, []);

  useEffect(() => {
    const tick = () => setDayCycle(getDayCycle());
    tick();
    const timer = window.setInterval(tick, 1000);
    return () => window.clearInterval(timer);
  }, []);

  // Las huellas se eliminan solas y están limitadas para evitar crecimiento de memoria.
  useEffect(() => {
    const timer = window.setInterval(() => {
      const cutoff = Date.now() - 6500;
      setFootprints((current) => current.filter((print) => print.createdAt >= cutoff));
    }, 1400);
    return () => window.clearInterval(timer);
  }, []);


  // Cuando Agriculture abre un modal, el mundo se congela de inmediato.
  useEffect(() => {
    const onAgricultureModalState = (event) => {
      if (!event?.detail?.open) return;
      keysRef.current.clear();
      joystickRef.current = { x: 0, y: 0 };
      setJoystick({ x: 0, y: 0 });
      walkTargetRef.current = null;
      setWalkTarget(null);
      pointerDriveRef.current = { active: false, pointerId: null };
      stuckFramesRef.current = 0;
    };
    window.addEventListener('cityfarm:agriculture:modal-state', onAgricultureModalState);
    return () => window.removeEventListener('cityfarm:agriculture:modal-state', onAgricultureModalState);
  }, []);


  useEffect(() => {
    const onKeyDown = (event) => {
      const target = event.target;
      const editing =
        target?.tagName === 'INPUT' ||
        target?.tagName === 'TEXTAREA' ||
        target?.isContentEditable;
      if (editing) return;

      const key = event.key.toLowerCase();
      if (document.body?.classList?.contains('cfagri-modal-open')) {
        if (['w', 'a', 's', 'd', 'arrowup', 'arrowdown', 'arrowleft', 'arrowright', 'e', '+', '=', '-', '0'].includes(key)) {
          event.preventDefault();
        }
        return;
      }
      if (['w', 'a', 's', 'd', 'arrowup', 'arrowdown', 'arrowleft', 'arrowright'].includes(key)) {
        event.preventDefault();
        keysRef.current.add(key);
        if (walkTargetRef.current) {
          walkTargetRef.current = null;
          setWalkTarget(null);
          stuckFramesRef.current = 0;
        }
      }
      if (key === 'e') {
        event.preventDefault();
        setSelectedBuildingId((current) => current || '__nearest__');
      }
      if (key === '+' || key === '=') {
        event.preventDefault();
        setSafeZoom((current) => current + ZOOM_STEP);
      }
      if (key === '-') {
        event.preventDefault();
        setSafeZoom((current) => current - ZOOM_STEP);
      }
      if (key === '0') {
        event.preventDefault();
        fitFarm();
      }
    };

    const onKeyUp = (event) => {
      keysRef.current.delete(event.key.toLowerCase());
    };

    const onBlur = () => keysRef.current.clear();

    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('keyup', onKeyUp);
    window.addEventListener('blur', onBlur);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('keyup', onKeyUp);
      window.removeEventListener('blur', onBlur);
    };
  }, [fitFarm, setSafeZoom]);

  useEffect(() => {
    const movementVisual = movementVisualRef.current;

    const updateMovementVisual = (moving, x, y) => {
      let nextFacing = movementVisual.facing;
      if (moving) {
        if (Math.abs(x) > Math.abs(y)) nextFacing = x < 0 ? 'left' : 'right';
        else if (Math.abs(y) > 0.05) nextFacing = y < 0 ? 'up' : 'down';
      }

      if (movementVisual.moving !== moving) {
        movementVisual.moving = moving;
        setIsMoving(moving);
      }
      if (movementVisual.facing !== nextFacing) {
        movementVisual.facing = nextFacing;
        setFacing(nextFacing);
      }
    };

    const clearTarget = () => {
      if (!walkTargetRef.current) return;
      walkTargetRef.current = null;
      setWalkTarget(null);
      stuckFramesRef.current = 0;
    };

    const frame = (time) => {
      const previous = lastFrameRef.current ?? time;
      const dt = Math.min((time - previous) / 1000, 0.04);
      lastFrameRef.current = time;

      if (document.body?.classList?.contains('cfagri-modal-open')) {
        keysRef.current.clear();
        joystickRef.current = { x: 0, y: 0 };
        clearTarget();
        updateMovementVisual(false, 0, 0);
        rafRef.current = requestAnimationFrame(frame);
        return;
      }

      let x = 0;
      let y = 0;
      const keys = keysRef.current;

      if (keys.has('a') || keys.has('arrowleft')) x -= 1;
      if (keys.has('d') || keys.has('arrowright')) x += 1;
      if (keys.has('w') || keys.has('arrowup')) y -= 1;
      if (keys.has('s') || keys.has('arrowdown')) y += 1;

      x += joystickRef.current.x;
      y += joystickRef.current.y;

      const manualLength = Math.hypot(x, y);
      const usingManualControl = manualLength > 0.02;

      if (usingManualControl && walkTargetRef.current) {
        clearTarget();
      }

      if (!usingManualControl && walkTargetRef.current) {
        const target = walkTargetRef.current;
        const current = playerRef.current;
        const dx = target.x - current.x;
        const dy = target.y - current.y;
        const distance = Math.hypot(dx, dy);

        if (distance <= WALK_TARGET_TOLERANCE) {
          clearTarget();
        } else {
          x = dx / distance;
          y = dy / distance;
        }
      }

      const length = Math.hypot(x, y);
      const moving = length > 0.02;
      updateMovementVisual(moving, x, y);

      if (moving) {
        const normalizedX = x / Math.max(1, length);
        const normalizedY = y / Math.max(1, length);
        const moved = movePlayer(normalizedX * PLAYER_SPEED * dt, normalizedY * PLAYER_SPEED * dt);

        if (moved && time - lastFootprintAtRef.current > 230) {
          lastFootprintAtRef.current = time;
          const currentPos = playerRef.current;
          footprintSeqRef.current += 1;
          const nextPrint = {
            id: footprintSeqRef.current,
            x: currentPos.x,
            y: currentPos.y + 14,
            facing: movementVisual.facing,
            createdAt: Date.now(),
          };
          setFootprints((current) => [...current.slice(-21), nextPrint]);
        }

        if (walkTargetRef.current && !usingManualControl) {
          if (moved) {
            stuckFramesRef.current = 0;
          } else {
            stuckFramesRef.current += 1;
            if (stuckFramesRef.current > 24) {
              clearTarget();
              setMessage(tr.routeBlocked);
            }
          }
        }
      }

      rafRef.current = requestAnimationFrame(frame);
    };

    rafRef.current = requestAnimationFrame(frame);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      lastFrameRef.current = null;
      movementVisual.moving = false;
    };
  }, [movePlayer, tr.routeBlocked]);

  const nearestBuilding = useMemo(() => {
    let result = null;
    let bestDistance = Infinity;
    placedBuildings.forEach((building) => {
      const distance = distanceToRect(player.x, player.y, building.collider);
      if (distance < bestDistance) {
        bestDistance = distance;
        result = building;
      }
    });
    if (bestDistance <= INTERACTION_DISTANCE) return { building: result, distance: bestDistance };
    return null;
  }, [player, placedBuildings]);

  // Las 6 parcelas agrícolas participan en el mismo sistema de proximidad que los edificios.
  const nearestSimpleField = useMemo(() => {
    let result = null;
    let bestDistance = Infinity;
    placedSimpleFields.forEach((field) => {
      if (field?.visible === false) return;
      const rect = { x: field.x, y: field.y, w: field.width, h: field.height };
      const distance = distanceToRect(player.x, player.y, rect);
      if (distance < bestDistance) {
        bestDistance = distance;
        result = field;
      }
    });
    if (bestDistance <= INTERACTION_DISTANCE) return { field: result, distance: bestDistance };
    return null;
  }, [player, placedSimpleFields]);

  const nearestWorldInteraction = useMemo(() => {
    if (!nearestBuilding && !nearestSimpleField) return null;
    if (!nearestBuilding) return { type: 'field', ...nearestSimpleField };
    if (!nearestSimpleField) return { type: 'building', ...nearestBuilding };
    return nearestSimpleField.distance <= nearestBuilding.distance
      ? { type: 'field', ...nearestSimpleField }
      : { type: 'building', ...nearestBuilding };
  }, [nearestBuilding, nearestSimpleField]);

  useEffect(() => {
    if (selectedBuildingId !== '__nearest__') return;

    if (nearestWorldInteraction?.type === 'field') {
      const plotId = Number(String(nearestWorldInteraction.field?.id || '').split('-').pop());
      setSelectedBuildingId(null);
      if (Number.isInteger(plotId) && plotId >= 1 && plotId <= 6) {
        window.dispatchEvent(new CustomEvent('cityfarm:agriculture:open', { detail: { plotId } }));
                        setMessage(language === 'en' ? `Agriculture plot ${plotId}` : `Parcela agrícola ${plotId}`);
      }
      return;
    }

    if (nearestWorldInteraction?.type === 'building') {
      setSelectedBuildingId(nearestWorldInteraction.building.id);
      return;
    }

    setSelectedBuildingId(null);
    setMessage(language === 'en' ? 'Get closer to a building or agricultural plot.' : 'Acércate a un edificio o una parcela agrícola.');
  }, [language, nearestWorldInteraction, selectedBuildingId]);

  const selectedBuilding = placedBuildings.find((building) => building.id === selectedBuildingId) || null;

  const camera = useMemo(() => {
    const scaledWidth = WORLD.width * zoom;
    const scaledHeight = WORLD.height * zoom;
    const desiredX = viewport.width / 2 - player.x * zoom + cameraOffset.x;
    const desiredY = viewport.height / 2 - player.y * zoom + cameraOffset.y;
    return {
      x: scaledWidth <= viewport.width ? (viewport.width - scaledWidth) / 2 : clamp(desiredX, viewport.width - scaledWidth, 0),
      y: scaledHeight <= viewport.height ? (viewport.height - scaledHeight) / 2 : clamp(desiredY, viewport.height - scaledHeight, 0),
    };
  }, [player, viewport, zoom, cameraOffset]);

  const centerOnAvatar = () => {
    setCameraOffset({ x: 0, y: 0 });
    setPanMode(false);
  };

  const setWalkTargetFromPointer = (event) => {
    const node = viewportRef.current;
    if (!node) return;
    const rect = node.getBoundingClientRect();
    const target = {
      x: clamp((event.clientX - rect.left - camera.x) / zoom, 45, WORLD.width - 45),
      y: clamp((event.clientY - rect.top - camera.y) / zoom, 80, WORLD.height - 45),
    };
    walkTargetRef.current = target;
    setWalkTarget(target);
    stuckFramesRef.current = 0;
    setShowHelp(false);
  };

  const pointerIsOnControl = (event) => {
    const target = event.target;
    return Boolean(
      target?.closest?.(
        '.cfv2-building, .cfv2-simple-field, .cfagri-plot, .cfagri-modal-backdrop, .cfagri-panel, .cfagri-error-toast, .cfv2-joystick-pad, .cfv2-action, .cfv2-panel-backdrop, .cfv2-back, .cfv2-menu-toggle, .cfv2-game-menu, .cfv2-language, .cfv2-toolbar, .cfv2-zoom-controls, .cfv2-weather-button, .cfv2-decor-item, .cfv2-river-move-handle'
      )
    );
  };

  const startWorldPointer = (event) => {
    if (document.body?.classList?.contains('cfagri-modal-open') || layoutEditMode) return;
    if (pointerIsOnControl(event)) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    if (panMode) {
      event.preventDefault();
      // Capturamos solamente el espacio libre del mundo, no las construcciones.
      panPointerRef.current = { pointerId: event.pointerId, x: event.clientX, y: event.clientY };
      event.currentTarget.setPointerCapture?.(event.pointerId);
      setIsPanning(true);
      walkTargetRef.current = null;
      setWalkTarget(null);
      return;
    }
    event.preventDefault();
    pointerDriveRef.current = { active: true, pointerId: event.pointerId };
    event.currentTarget.setPointerCapture?.(event.pointerId);
    setWalkTargetFromPointer(event);
  };

  const moveWorldPointer = (event) => {
    const pan = panPointerRef.current;
    if (pan && pan.pointerId === event.pointerId) {
      event.preventDefault();
      const dx = event.clientX - pan.x;
      const dy = event.clientY - pan.y;
      pan.x = event.clientX;
      pan.y = event.clientY;
      setCameraOffset((current) => ({ x: current.x + dx, y: current.y + dy }));
      return;
    }
    if (document.body?.classList?.contains('cfagri-modal-open') || layoutEditMode) return;
    const drive = pointerDriveRef.current;
    if (!drive.active || drive.pointerId !== event.pointerId || pointerIsOnControl(event)) return;
    setWalkTargetFromPointer(event);
  };

  const stopWorldPointer = (event) => {
    if (panPointerRef.current?.pointerId === event.pointerId) {
      panPointerRef.current = null;
      setIsPanning(false);
      if (event.currentTarget.hasPointerCapture?.(event.pointerId)) event.currentTarget.releasePointerCapture(event.pointerId);
      return;
    }
    const drive = pointerDriveRef.current;
    if (!drive.active || drive.pointerId !== event.pointerId) return;
    pointerDriveRef.current = { active: false, pointerId: null };
    if (event.currentTarget.hasPointerCapture?.(event.pointerId)) event.currentTarget.releasePointerCapture(event.pointerId);
  };

  const handleWheelZoom = (event) => {
    // Un modal de Agriculture abierto bloquea también el zoom del mundo.
    if (document.body?.classList?.contains('cfagri-modal-open')) return;
    // Solo cambia la cámara. Nunca convierte la rueda en una acción de juego.
    event.preventDefault();
    const direction = event.deltaY < 0 ? 1 : -1;
    setSafeZoom((current) => current + direction * ZOOM_STEP);
  };

  const closeRealPanel = () => setActivePanel(null);

  const openRealPanel = (panel) => {
    if (!panel) return;

    if (panel.selectorKey) {
      const land = informacion?.tierras?.[panel.selectorKey];
      if (!land?.habilitado) {
        setMessage(tr.locked);
        setActivePanel(null);
        setSelectedBuildingId(null);
        return;
      }
    }

    setActivePanel(panel);
            setSelectedBuildingId(null);
    setMessage(tr.realReady);
  };

  const openRealBuilding = (building) => {
    const panel = BUILDING_REAL_PANEL[building?.id];
    if (!panel) return;
    if (panel.type === 'visit') {
      openVisitFarms();
      return;
    }
    if (panel.type === 'external' && panel.url === BIGDOG_BONE_URL) {
      window.open(BIGDOG_BONE_URL, '_blank', 'noopener,noreferrer');
      setSelectedBuildingId(null);
      setMessage(tr.externalOpened || 'Big Dog Bone');
      return;
    }
    openRealPanel(panel);
  };

  const openShortcut = (item) => {
    if (item.type === 'mill') {
      openRealPanel({ type: 'mill' });
      return;
    }
    openRealPanel({ type: item.type, selectorKey: item.selectorKey });
  };

  const openVisitFarms = () => {
            window.dispatchEvent(new Event('open-city-farms-panel'));
  };

  const openAgriculturePlot = (field) => {
    const match = String(field?.id || '').match(/^simple-field-([1-6])$/);
    if (!match) return;
    const plotId = Number(match[1]);
    window.dispatchEvent(new CustomEvent('cityfarm:agriculture:open', { detail: { plotId } }));
            setMessage(language === 'en' ? `Agriculture plot ${plotId}` : `Parcela agrícola ${plotId}`);
  };

  const activeSelector = activePanel?.selectorKey
    ? (informacion?.tierras?.[activePanel.selectorKey] || {})
    : {};

  const inspectBuilding = (building) => {
    const distance = distanceToRect(playerRef.current.x, playerRef.current.y, building.collider);
    if (distance > INTERACTION_DISTANCE) {
      setMessage(`${tr.moveCloser} ${BUILDING_NAMES[language]?.[building.id] || building.name}`);
      setSelectedBuildingId(null);
      return;
    }
    openRealBuilding(building);
  };

  const interactNearest = () => {
    if (!nearestWorldInteraction) {
      setMessage(language === 'en' ? 'Get closer to a building or agricultural plot.' : 'Acércate a un edificio o una parcela agrícola.');
      return;
    }
    if (nearestWorldInteraction.type === 'field') {
      openAgriculturePlot(nearestWorldInteraction.field);
      return;
    }
    openRealBuilding(nearestWorldInteraction.building);
  };

  const onJoystickPointer = (event) => {
    const pad = event.currentTarget;
    const rect = pad.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    let x = (event.clientX - centerX) / (rect.width * 0.34);
    let y = (event.clientY - centerY) / (rect.height * 0.34);
    const length = Math.hypot(x, y);
    if (length > 1) {
      x /= length;
      y /= length;
    }
    const vector = { x, y };
    joystickRef.current = vector;
    setJoystick(vector);
  };

  const startJoystick = (event) => {
    if (document.body?.classList?.contains('cfagri-modal-open')) return;
    event.preventDefault();
    if (walkTargetRef.current) {
      walkTargetRef.current = null;
      setWalkTarget(null);
      stuckFramesRef.current = 0;
    }
    event.currentTarget.setPointerCapture?.(event.pointerId);
    onJoystickPointer(event);
    setShowHelp(false);
  };

  const stopJoystick = (event) => {
    event.currentTarget.releasePointerCapture?.(event.pointerId);
    joystickRef.current = { x: 0, y: 0 };
    setJoystick({ x: 0, y: 0 });
  };

  const logoutToLogin = () => {
    try {
      // El login real de CITYFARM guarda el JWT en la cookie `token`.
      document.cookie = 'token=; Max-Age=0; path=/; SameSite=Strict;';
      document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;';

      // Algunas funciones clásicas usan `sessionStorage.user`.
      // Se limpia únicamente la sesión; no borramos layout ni preferencias visuales.
      window.sessionStorage.removeItem('user');
    } catch (_) {}

    // Quita #/v2 y fuerza a Inicio a arrancar nuevamente en la pantalla de login.
    const loginUrl = `${window.location.pathname}${window.location.search}`;
    window.location.replace(loginUrl);
  };

  return (
    <div
      className={`cfv2-root ${premiumVisual ? 'cfv2-premium-skin' : ''} weather-${effectiveWeather} ${groundWet ? 'ground-wet' : ''} ${groundWetness > 0.62 ? 'ground-soaked' : groundWetness > 0.18 ? 'ground-damp' : ''} ${zoom < 0.42 ? 'zoom-far' : ''} ${layoutEditMode ? 'layout-editing' : ''} ${roadsCustomized ? 'roads-customized' : ''} ${!layerVisibility.river ? 'layers-river-off' : ''} ${!layerVisibility.roads ? 'layers-roads-off' : ''} ${!layerVisibility.fields ? 'layers-fields-off' : ''} ${!layerVisibility.decorations ? 'layers-decorations-off' : ''} ${!layerVisibility.labels ? 'layers-labels-off' : ''} ${!layerVisibility.traffic ? 'layers-traffic-off' : ''} ${!layerVisibility.animals ? 'layers-animals-off' : ''} ${!layerVisibility.trees ? 'layers-trees-off' : ''} ${!layerVisibility.lamps ? 'layers-lamps-off' : ''} ${!layerVisibility.weather ? 'layers-weather-off' : ''} ${!layerVisibility.particles ? 'layers-particles-off' : ''}`}
      style={{ '--cfv2-wetness': groundWetness.toFixed(3) }}
    >
      <header className="cfv2-topbar">
        <div className="cfv2-brand">
          <span className="cfv2-title">CITY FARM V2</span>
          <span className="cfv2-beta">{tr.beta}</span>
        </div>

        <div className="cfv2-hud" aria-label="Player resources">
          <div className={`cfv2-hud-player ${hiveConnected ? 'is-hive' : 'is-no-hive'}`} title={hiveConnected ? `Hive ${hiveDisplay}` : tr.hiveMissing}>
            <span className="cfv2-avatar">🐝</span>
            <span className="cfv2-hud-name">{hiveDisplay}</span>
            <span className="cfv2-hud-level">Lv. {formatNumber(playerLevel)}</span>
          </div>
          <div className="cfv2-resource"><span>🪙</span><strong>{formatNumber(cfBalance)}</strong></div>
          <div className="cfv2-resource"><span>⚡</span><strong>{formatNumber(energyBalance)}</strong></div>
          <div className="cfv2-resource"><span>💧</span><strong>{formatNumber(waterBalance)}</strong></div>
          <div className="cfv2-time-chip" title="CITYFARM real UTC time">
            <span className="cfv2-time-icon">{dayCycle.icon}</span>
            <strong className="cfv2-time-clock">{dayCycle.utcLabel}</strong>
            <span className="cfv2-time-phase">{tr.phase[dayCycle.phase] || dayCycle.phase}</span>
          </div>
        </div>

        <div className="cfv2-toolbar">
          <div className="cfv2-toolbar-context">
            <span className="cfv2-toolbar-world">{tr.world}</span>
            <span className="cfv2-toolbar-message" aria-live="polite">{message}</span>
          </div>

          <div className="cfv2-toolbar-actions">
            <button type="button" className={`cfv2-pan-toggle ${panMode ? 'is-active' : ''}`} aria-pressed={panMode}
              title={language === 'en' ? 'Drag empty ground to move camera' : 'Arrastra el terreno libre para mover la cámara'}
              onClick={() => { setPanMode((value) => !value); panPointerRef.current = null; setIsPanning(false); walkTargetRef.current = null; setWalkTarget(null); }}>
              ✋ <span>{language === 'en' ? 'MAP' : 'MAPA'}</span>
            </button>
            <button type="button" className="cfv2-camera-recenter" onClick={centerOnAvatar} title={language === 'en' ? 'Center on avatar' : 'Centrar en personaje'}>◎ <span>{language === 'en' ? 'CENTER' : 'CENTRAR'}</span></button>

            <button
              type="button"
              className={`cfv2-premium-toggle ${premiumVisual ? 'is-active' : ''}`}
              onClick={togglePremiumVisual}
              title={language === 'en' ? 'Switch between illustrated and classic map' : 'Alternar mapa ilustrado y clásico'}
              aria-pressed={premiumVisual}
            >
              ✨ {premiumVisual ? (language === 'en' ? 'ILLUSTRATED' : 'ILUSTRADO') : (language === 'en' ? 'CLASSIC MAP' : 'MAPA CLÁSICO')}
            </button>
            <div className="cfv2-zoom-controls" role="group" aria-label={tr.zoom}>
              <button type="button" onClick={() => setSafeZoom((current) => current - ZOOM_STEP)} aria-label="Zoom out">−</button>
              <button type="button" className="cfv2-zoom-fit" onClick={fitFarm} title={tr.fitMap}>
                ◫ {Math.round(zoom * 100)}%
              </button>
              <button type="button" onClick={() => setSafeZoom((current) => current + ZOOM_STEP)} aria-label="Zoom in">+</button>
            </div>

            <div
              className={`cfv2-weather-button cfv2-weather-auto weather-${effectiveWeather}`}
              role="status"
              aria-live="polite"
              title={`${tr.weatherHint} · ${tr.weatherAuto} · ${formatDurationMMSS(autoWeatherState.timeRemainingSeconds)} · ${language === 'en' ? 'Next' : 'Siguiente'}: ${language === 'en' ? nextWeatherInfo.en : nextWeatherInfo.es}`}
            >
              <span>{weatherInfo.icon}</span>
              <b>{language === 'en' ? weatherInfo.en : weatherInfo.es}</b>
              <small className="cfv2-weather-cycle">AUTO · {formatDurationMMSS(autoWeatherState.timeRemainingSeconds)}</small>
              {groundWet && effectiveWeather !== 'rain' && effectiveWeather !== 'storm' && (
                <small className="cfv2-wet-indicator" title={tr.wetGround}>{groundWetness > 0.62 ? '💦' : '💧'}</small>
              )}
            </div>

            <button
              type="button"
              className={`cfv2-top-interact ${nearestWorldInteraction && !layoutEditMode ? 'is-ready' : ''}`}
              onClick={interactNearest}
              disabled={!nearestWorldInteraction || layoutEditMode}
              title={nearestWorldInteraction
                ? (nearestWorldInteraction.type === 'field'
                    ? `${language === 'en' ? 'Agriculture plot' : 'Parcela agrícola'} ${String(nearestWorldInteraction.field?.id || '').split('-').pop()}`
                    : (BUILDING_NAMES[language]?.[nearestWorldInteraction.building.id] || nearestWorldInteraction.building.name))
                : tr.approach}
            >
              ⚡ <span>{nearestWorldInteraction ? tr.interact : tr.approach}</span>
            </button>

            <div className={`cfv2-layers-controls ${layersOpen ? 'is-active' : ''}`}>
              <button
                type="button"
                className={`cfv2-layers-toggle ${layersOpen ? 'is-open' : ''}`}
                onClick={() => { setLayersOpen((v) => !v); }}
                aria-expanded={layersOpen}
              >
                🗂 {tr.layers}
              </button>

              {layersOpen && (
                <div className="cfv2-layers-menu" role="menu" aria-label={tr.layersTitle}>
                  <strong>{tr.layersTitle}</strong>
                  <p>{tr.layersHint}</p>
                  <div className="cfv2-layers-grid">
                    {LAYER_DEFS.map((layer) => (
                      <button
                        key={layer.id}
                        type="button"
                        className={layerVisibility[layer.id] ? 'is-on' : 'is-off'}
                        onClick={() => toggleLayerVisibility(layer.id)}
                      >
                        <span>{layer.icon} {language === 'en' ? layer.en : layer.es}</span>
                        <small>{layerVisibility[layer.id] ? 'ON' : 'OFF'}</small>
                      </button>
                    ))}
                  </div>
                  <button type="button" className="cfv2-layers-reset" onClick={resetLayerVisibility}>↺ {tr.resetLayers}</button>
                </div>
              )}
            </div>

            <div className={`cfv2-arrange-controls ${layoutEditMode ? 'is-active' : ''}`}>
              {!layoutEditMode ? (
                <button
                  type="button"
                  className="cfv2-arrange-toggle"
                  onClick={() => {
                    setLayoutEditMode(true);
                    setSelectedRoadId(null);
                    setSelectedFieldId(null);
                    setPlazaSelected(false);
                    setSelectedCreativeId(null);
                    setCreativeCatalogOpen(false);
                    setLayersOpen(false);
                    setSelectedBuildingId(null);
                    walkTargetRef.current = null;
                    setWalkTarget(null);
                    setMessage(tr.arranging);
                  }}
                >
                  ✥ {tr.arrange}
                </button>
              ) : (
                <>
                  <button type="button" className="cfv2-arrange-done" onClick={finishArrange}>✓ {tr.doneArrange}</button>
                  <button type="button" className="cfv2-arrange-reset" onClick={resetFarmLayout}>↺ {tr.resetLayout}</button>
                </>
              )}
            </div>

            {layoutEditMode && selectedTree && (
              <div className="cfv2-context-editor">
                <span>🌳 {language === 'en' ? 'Selected tree' : 'Árbol seleccionado'}</span>
                <button type="button" onClick={() => { setObjectVisibility(selectedTree.id, false); setSelectedTreeId(null); }}>
                  🗑 {language === 'en' ? 'Hide tree' : 'Ocultar árbol'}
                </button>
              </div>
            )}

            {layoutEditMode && (
              <div className="cfv2-piece-library">
                <button type="button" className="cfv2-piece-library-toggle"
                  aria-expanded={creativeCatalogOpen}
                  onClick={() => setCreativeCatalogOpen((value) => !value)}>
                  📦 {language === 'en' ? 'Pieces & floors' : 'Piezas y pisos'}
                  {restoreHiddenObjects.length > 0 && <span className="cfv2-piece-count">{restoreHiddenObjects.length}</span>}
                  <span aria-hidden="true">{creativeCatalogOpen ? '▴' : '▾'}</span>
                </button>
              </div>
            )}

            {layoutEditMode && selectedRoad && (
              <div className="cfv2-road-editor-controls cfv2-context-editor" role="group" aria-label={tr.roadEditor}>
                <span>🛣️ {tr.roadEditor}</span>
                <button type="button" onClick={rotateSelectedRoad}>↻ {tr.rotateRoad}</button>
                <button type="button" onClick={cycleSelectedRoadType}>⌁ {tr.changeRoad}</button>
                <button type="button" onClick={() => updateSelectedRoad({ visible: !selectedRoad.visible })}>{selectedRoad.visible ? '👁‍🗨' : '👁'} {selectedRoad.visible ? tr.hide : tr.show}</button>
                <select value={selectedRoad.replacement} onChange={(event) => updateSelectedRoad({ replacement: event.target.value, visible: true })} aria-label={tr.roadReplacement}>
                  <option value="none">🛣️ {tr.noReplacement}</option>
                  {ROAD_REPLACEMENTS.filter((item) => item !== 'none').map((item) => (
                    <option key={item} value={item}>{CREATIVE_DECOR_LABELS[item] ? (language === 'en' ? CREATIVE_DECOR_LABELS[item].en : CREATIVE_DECOR_LABELS[item].es) : item}</option>
                  ))}
                </select>
                <small>{selectedRoad.kind === 'straight' ? tr.roadStraight : selectedRoad.kind === 'curve' ? tr.roadCurve : selectedRoad.kind === 't' ? tr.roadT : tr.roadCross} · {selectedRoad.rotation}°</small>
              </div>
            )}

            {layoutEditMode && selectedSimpleField && (
              <div className="cfv2-context-editor" role="group" aria-label={tr.fieldEditor}>
                <span>🌱 {tr.fieldEditor}</span>
                <button type="button" onClick={() => updateSelectedField({ variant: (selectedSimpleField.variant + 1) % 3 })}>🎨 {tr.changeCropStyle}</button>
                <button type="button" onClick={() => updateSelectedField({ visible: !selectedSimpleField.visible })}>{selectedSimpleField.visible ? '👁‍🗨' : '👁'} {selectedSimpleField.visible ? tr.hide : tr.show}</button>
              </div>
            )}

            {layoutEditMode && plazaSelected && (
              <div className="cfv2-context-editor cfv2-plaza-editor-controls" role="group" aria-label={tr.plazaEditor}>
                <span>🏛️ {tr.plazaEditor}</span>
                <button type="button" onClick={() => updatePlaza({ style: PLAZA_STYLES[(PLAZA_STYLES.indexOf(placedPlaza.style) + 1) % PLAZA_STYLES.length] })}>🎨 {tr.plazaStyle}</button>
                <button type="button" onClick={() => updatePlaza({ visible: !placedPlaza.visible })}>{placedPlaza.visible ? '👁‍🗨' : '👁'} {placedPlaza.visible ? tr.hide : tr.show}</button>
                <div className="cfv2-plaza-accessory-picks" aria-label={tr.plazaAccessories}>
                  {PLAZA_ACCESSORIES.map((item) => (
                    <button key={item} type="button" className={placedPlaza.accessories.includes(item) ? 'is-active' : ''} onClick={() => togglePlazaAccessory(item)} title={item}>{item === 'fountain' ? '⛲' : item === 'tree' ? '🌳' : item === 'flowers' ? '🌷' : item === 'bench' ? '🪑' : item === 'lamps' ? '💡' : '🪧'}</button>
                  ))}
                </div>
              </div>
            )}

            {layoutEditMode && selectedCreativeDecor && (
              <div className="cfv2-context-editor" role="group" aria-label={tr.creativeTitle}>
                <span>✨ {language === 'en' ? CREATIVE_DECOR_LABELS[selectedCreativeDecor.type].en : CREATIVE_DECOR_LABELS[selectedCreativeDecor.type].es}</span>
                <button type="button" onClick={() => updateSelectedCreative({ rotation: (selectedCreativeDecor.rotation + 90) % 360 })}>↻ {tr.rotateDecoration}</button>
                <select value={selectedCreativeDecor.type} onChange={(event) => updateSelectedCreative({ type: event.target.value })} aria-label={tr.decorType}>
                  {CREATIVE_DECOR_TYPES.map((type) => <option key={type} value={type}>{language === 'en' ? CREATIVE_DECOR_LABELS[type].en : CREATIVE_DECOR_LABELS[type].es}</option>)}
                </select>
                <button type="button" onClick={() => updateSelectedCreative({ visible: false })}>🗑 {tr.removeDecoration}</button>
              </div>
            )}

            <CityFarmOperationHistory language={language} />

            <button
              type="button"
              className="cfv2-whitepaper-button"
              onClick={() => {
                setWhitepaperOpen(true);
                setLayersOpen(false);
                setCreativeCatalogOpen(false);
                setSelectedBuildingId(null);
                walkTargetRef.current = null;
                setWalkTarget(null);
              }}
              title={tr.whitepaper}
              aria-label={tr.whitepaper}
            >
              📖 {tr.whitepaper}
            </button>

            <div className="cfv2-language" aria-label={tr.language}>
              <button type="button" className={language === 'en' ? 'is-active' : ''} onClick={() => changeLanguage('en')}>EN</button>
              <button type="button" className={language === 'es' ? 'is-active' : ''} onClick={() => changeLanguage('es')}>ES</button>
            </div>

            {classicEnabled && (
              <button type="button" className="cfv2-back" onClick={onBack}>
                {tr.classic}
              </button>
            )}

            <button
              type="button"
              className="cfv2-logout"
              onClick={logoutToLogin}
              title={tr.logout}
              aria-label={tr.logout}
            >
              ⏻ {tr.logout}
            </button>
          </div>

        </div>
      </header>
      {layoutEditMode && creativeCatalogOpen && createPortal(
        <div className="cfv2-piece-modal-backdrop" onPointerDown={(event) => { if (event.target === event.currentTarget) setCreativeCatalogOpen(false); }}>
          <div className="cfv2-piece-library-popover" role="dialog" aria-modal="true" aria-label={language === 'en' ? 'Pieces and floors' : 'Piezas y pisos'}>
                    <div className="cfv2-piece-library-head">
                      <strong>📦 {language === 'en' ? 'Construction library' : 'Biblioteca de construcción'}</strong>
                      <button type="button" aria-label={language === 'en' ? 'Close library' : 'Cerrar biblioteca'}
                        onClick={() => setCreativeCatalogOpen(false)}>✕</button>
                    </div>
                    <section>
                      <h4>{language === 'en' ? 'Stored / hidden' : 'Guardados / ocultos'} ({restoreHiddenObjects.length})</h4>
                      {restoreHiddenObjects.length === 0
                        ? <p>{language === 'en' ? 'No hidden pieces.' : 'No hay piezas ocultas.'}</p>
                        : <div className="cfv2-piece-library-grid">
                          {restoreHiddenObjects.map((item) => (
                            <button key={item.id} type="button" onClick={() => setObjectVisibility(item.id, true)}>
                              ↩ {item.label}
                            </button>
                          ))}
                        </div>}
                    </section>
                    <section>
                      <h4>{language === 'en' ? 'Create new piece' : 'Crear pieza nueva'}</h4>
                      <div className="cfv2-construction-tabs" role="tablist" aria-label={language === 'en' ? 'Construction categories' : 'Categorías de construcción'}>
                        {[['floors', language === 'en' ? 'Floors & ground' : 'Pisos y terrenos'], ['fences', language === 'en' ? 'Fences & gates' : 'Cercas y portones'], ['roads', language === 'en' ? 'Roads' : 'Calles'], ['decor', language === 'en' ? 'Decorations' : 'Decoración']].map(([key,label]) => (
                          <button type="button" role="tab" key={key} aria-selected={constructionTab === key} className={constructionTab === key ? 'active' : ''} onClick={() => setConstructionTab(key)}>{label}</button>
                        ))}
                      </div>
                      <div className="cfv2-piece-library-grid cfv2-piece-library-create" role="tabpanel">
                        {constructionTab === 'roads' ? ROAD_TYPES.map((kind) => (
                          <button key={kind} type="button" onClick={() => addRoadPiece(kind)}>
                            <span>🛣️</span>
                            {({ straight: language === 'en' ? 'Straight road' : 'Calle recta', curve: language === 'en' ? 'Curve' : 'Curva', t: language === 'en' ? 'T junction' : 'Intersección T', cross: language === 'en' ? 'Crossroads' : 'Cruce' })[kind]}
                          </button>
                        )) : (constructionTab === 'floors' ? FLOOR_TYPES : constructionTab === 'fences' ? FENCE_TYPES : DECOR_TYPES).map((type) => (
                          <button key={type} type="button" onClick={() => addCreativeDecoration(type)}>
                            <span>{type.startsWith('ground-') ? '▦' : type.startsWith('fence-') ? '🪵' : '✿'}</span>
                            {language === 'en' ? CREATIVE_DECOR_LABELS[type].en : CREATIVE_DECOR_LABELS[type].es}
                          </button>
                        ))}
                      </div>
                    </section>
          </div>
        </div>, document.body
      )}

      <CityFarmWhitepaper
        open={whitepaperOpen}
        onClose={() => setWhitepaperOpen(false)}
        initialLanguage={language}
      />

      <div
        ref={viewportRef}
        className={`cfv2-viewport ${panMode ? 'cfv2-pan-enabled' : ''} ${isPanning ? 'cfv2-is-panning' : ''}`}
        tabIndex={0}
        role="application"
        aria-label="City Farm V2"
        onPointerDown={startWorldPointer}
        onPointerMove={moveWorldPointer}
        onPointerUp={stopWorldPointer}
        onPointerCancel={stopWorldPointer}
        onContextMenu={(event) => event.preventDefault()}
        onWheel={handleWheelZoom}
      >
        <div
          className="cfv2-world"
          style={{
            width: WORLD.width,
            height: WORLD.height,
            backgroundImage: premiumVisual ? 'none' : `url(${grass})`,
            backgroundColor: premiumVisual ? '#6e9c3d' : undefined,
            backgroundSize: undefined,
            backgroundRepeat: undefined,
            transform: `translate3d(${camera.x}px, ${camera.y}px, 0) scale(${zoom})`,
          }}
        >
          {premiumVisual && (
            <>
              <div className="cfv2-native-meadow" aria-hidden="true" />
              <div className="cfv2-native-water" aria-hidden="true" />
            </>
          )}
          <div className="cfv2-terrain-detail" aria-hidden="true" />

          {placedSimpleFields.map((field, index) => {
            if (!field.visible && !layoutEditMode) return null;
            const selected = layoutEditMode && selectedFieldId === field.id;
            const near = !layoutEditMode && nearestSimpleField?.field?.id === field.id;
            return (
            <button
              key={field.id}
              type="button"
              className={`cfv2-simple-field field-variant-${field.variant} ${selected ? 'is-selected' : ''} ${near ? 'is-near' : ''} ${!field.visible ? 'is-hidden-ghost' : ''}`}
              style={{ left: field.x, top: field.y, width: field.width, height: field.height, zIndex: 34 + field.y }}
              onPointerDown={(event) => {
                if (layoutEditMode) { setSelectedFieldId(field.id); setSelectedRoadId(null); setPlazaSelected(false); setSelectedCreativeId(null); }
                startDecorDrag(event, field);
              }}
              onPointerMove={(event) => moveDecorDrag(event, field)}
              onPointerUp={stopDecorDrag}
              onPointerCancel={stopDecorDrag}
              onClick={(event) => {
                if (layoutEditMode) {
                  event.preventDefault();
                  event.stopPropagation();
                  setSelectedFieldId(field.id);
                  return;
                }
                if (near) {
                  event.preventDefault();
                  event.stopPropagation();
                  openAgriculturePlot(field);
                }
              }}
              aria-label={`${tr.expansionField} ${index + 1}`}
            >
              <span className="cfv2-simple-field-soil" aria-hidden="true" />
              <span className="cfv2-simple-field-rows" aria-hidden="true" />
              {layoutEditMode
                ? <small>{!field.visible ? `👁 ${tr.show}` : `${tr.expansionField} ${index + 1}`}</small>
                : near ? <small>⚡ {tr.interact} · {language === 'en' ? 'PLOT' : 'PARCELA'} {index + 1}</small> : null}
            </button>
            );
          })}

          <CityFarmAgricultureV2
            plots={placedSimpleFields}
            language={language}
            weather={effectiveWeather}
            layoutEditMode={layoutEditMode}
            nearbyPlotId={nearestSimpleField?.field?.id ? Number(String(nearestSimpleField.field.id).split('-').pop()) : null}
          />

          <div className="cfv2-river-layer" aria-hidden="true">
            <svg
              className="cfv2-river-svg"
              viewBox={`0 0 ${WORLD.width} ${WORLD.height}`}
              preserveAspectRatio="none"
            >
              <defs>
                <clipPath id="cfv2-river-clip">
                  <rect x="0" y="0" width={WORLD.width} height={WORLD.height} rx="8" ry="8" />
                </clipPath>
                <linearGradient id="cfv2-river-water" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#154b70" />
                  <stop offset="20%" stopColor="#226f9f" />
                  <stop offset="50%" stopColor="#58c3e4" />
                  <stop offset="78%" stopColor="#2e88bc" />
                  <stop offset="100%" stopColor="#113f61" />
                </linearGradient>
                <linearGradient id="cfv2-river-edge" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="rgba(255,255,255,.24)" />
                  <stop offset="100%" stopColor="rgba(255,255,255,0)" />
                </linearGradient>
                <linearGradient id="cfv2-waterfall-water" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0%" stopColor="#1e678f" />
                  <stop offset="45%" stopColor="#afe7f7" />
                  <stop offset="60%" stopColor="#e9fcff" />
                  <stop offset="100%" stopColor="#2b86b5" />
                </linearGradient>
                <filter id="cfv2-river-soft-shadow" x="-20%" y="-20%" width="140%" height="160%">
                  <feDropShadow dx="0" dy="10" stdDeviation="10" floodColor="#071b23" floodOpacity=".32" />
                </filter>
                <filter id="cfv2-waterfall-mist" x="-40%" y="-40%" width="180%" height="180%">
                  <feGaussianBlur stdDeviation="7" />
                </filter>
              </defs>

              <g clipPath="url(#cfv2-river-clip)">
                <g className="cfv2-river-draggable-group" transform={`translate(${placedRiver.x} ${placedRiver.y})`}>
                {RIVER_BEACHES.map((beach) => (
                  <g key={beach.id} className="cfv2-river-beach" transform={`translate(${beach.x} ${beach.y}) rotate(${beach.rotate})`}>
                    <ellipse className="cfv2-river-beach-shadow" cx="0" cy="8" rx={beach.rx + 10} ry={beach.ry + 5} />
                    <ellipse className="cfv2-river-beach-sand" cx="0" cy="0" rx={beach.rx} ry={beach.ry} />
                    <ellipse className="cfv2-river-beach-light" cx={-Math.round(beach.rx * .18)} cy={-Math.round(beach.ry * .15)} rx={Math.round(beach.rx * .55)} ry={Math.round(beach.ry * .38)} />
                  </g>
                ))}
                <path className="cfv2-river-bank-outer" d={RIVER_PATH} />
                <path className="cfv2-river-bank-inner" d={RIVER_PATH} />
                <path className="cfv2-river-water" d={RIVER_PATH} filter="url(#cfv2-river-soft-shadow)" />
                <path className="cfv2-river-surface" d={RIVER_PATH} />
                <path className="cfv2-river-shallow" d={RIVER_PATH} />
                <path className="cfv2-river-current current-a" d={RIVER_PATH} />
                <path className="cfv2-river-current current-b" d={RIVER_PATH} />
                <path className="cfv2-river-ripple ripple-a" d={RIVER_PATH} />
                <path className="cfv2-river-ripple ripple-b" d={RIVER_PATH} />
                <path className="cfv2-river-highlight" d={RIVER_PATH} />
                {RIVER_SIDE_FOAM.map((foam) => (
                  <g key={foam.id} className="cfv2-river-side-foam" transform={`translate(${foam.x} ${foam.y}) rotate(${foam.rotate})`}>
                    <ellipse className="cfv2-river-side-foam-main" cx="0" cy="0" rx={foam.rx} ry={foam.ry} />
                    <ellipse className="cfv2-river-side-foam-sub" cx={foam.rx * .3} cy="2" rx={foam.rx * .42} ry={foam.ry * .66} />
                  </g>
                ))}

                {RIVER_REEDS.map((reed) => (
                  <g
                    key={reed.id}
                    className={`cfv2-river-reed ${reed.side === 'south' ? 'is-south' : 'is-north'}`}
                    transform={`translate(${reed.x} ${reed.y}) rotate(${reed.tilt})`}
                  >
                    <path d={`M 0 0 L 0 ${-reed.h}`} />
                    <path d={`M 2 -4 L 8 ${-Math.max(10, Math.round(reed.h * .7))}`} />
                    <path d={`M -2 -6 L -8 ${-Math.max(10, Math.round(reed.h * .65))}`} />
                  </g>
                ))}

                {RIVER_LILIES.map((lily) => (
                  <g key={lily.id} className="cfv2-river-lily" transform={`translate(${lily.x} ${lily.y})`}>
                    <circle className="cfv2-river-lily-pad" cx="0" cy="0" r={lily.r} />
                    <path className="cfv2-river-lily-cut" d={`M 0 0 L ${lily.r} 0`} />
                    <circle className="cfv2-river-lily-flower" cx={Math.round(lily.r * .18)} cy={-Math.round(lily.r * .1)} r={Math.max(3, Math.round(lily.r * .24))} />
                  </g>
                ))}

                {RIVER_ROCKS.map((rock) => (
                  <g
                    key={rock.id}
                    className="cfv2-river-rock"
                    transform={`translate(${rock.x} ${rock.y}) rotate(${rock.rotate})`}
                  >
                    <ellipse className="cfv2-river-rock-shadow" cx="0" cy="8" rx={rock.rx + 4} ry={rock.ry + 2} />
                    <ellipse className="cfv2-river-rock-body" cx="0" cy="0" rx={rock.rx} ry={rock.ry} />
                    <ellipse className="cfv2-river-rock-light" cx={-rock.rx * .25} cy={-rock.ry * .28} rx={rock.rx * .34} ry={rock.ry * .24} />
                  </g>
                ))}

                <g className="cfv2-waterfall">
                  <path className="cfv2-waterfall-cliff" d="M 3162 351 Q 3228 330 3290 360" />
                  <path className="cfv2-waterfall-sheet" d="M 3228 392 L 3228 555" />
                  <path className="cfv2-waterfall-stream stream-a" d="M 3198 395 L 3198 548" />
                  <path className="cfv2-waterfall-stream stream-b" d="M 3228 392 L 3228 560" />
                  <path className="cfv2-waterfall-stream stream-c" d="M 3258 395 L 3258 548" />
                  <ellipse className="cfv2-waterfall-mist" cx="3228" cy="567" rx="84" ry="28" filter="url(#cfv2-waterfall-mist)" />
                  <ellipse className="cfv2-waterfall-pool" cx="3230" cy="585" rx="112" ry="34" />
                  <ellipse className="cfv2-waterfall-foam foam-a" cx="3230" cy="577" rx="94" ry="20" />
                  <ellipse className="cfv2-waterfall-foam foam-b" cx="3230" cy="589" rx="62" ry="13" />
                  <circle className="cfv2-waterfall-splash splash-a" cx="3184" cy="558" r="7" />
                  <circle className="cfv2-waterfall-splash splash-b" cx="3270" cy="564" r="6" />
                  <circle className="cfv2-waterfall-splash splash-c" cx="3228" cy="548" r="5" />
                </g>
                </g>
              </g>
            </svg>
          </div>

          {layoutEditMode && layerVisibility.river && (
            <button
              type="button"
              className="cfv2-river-move-handle"
              style={{
                left: 1740 + placedRiver.x,
                top: 305 + placedRiver.y,
                zIndex: 950,
              }}
              onPointerDown={(event) => startDecorDrag(event, placedRiver)}
              onPointerMove={(event) => moveDecorDrag(event, placedRiver)}
              onPointerUp={stopDecorDrag}
              onPointerCancel={stopDecorDrag}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
              }}
              aria-label={language === 'en' ? 'Move large river' : 'Mover río grande'}
              title={language === 'en' ? 'Drag to move the whole river' : 'Arrastra para mover todo el río'}
            >
              <span>✥</span>
              <b>🌊 {language === 'en' ? 'MOVE RIVER' : 'MOVER RÍO'}</b>
            </button>
          )}

          <div className="cfv2-road-piece-layer" aria-label={language === 'en' ? 'Modular roads' : 'Calles modulares'}>
            {placedRoads.map((road) => {
              if (!road.visible) return null;
              const paths = ROAD_PATHS[road.kind] || ROAD_PATHS.straight;
              const selected = layoutEditMode && selectedRoadId === road.id;
              const roadReplaced = road.replacement && road.replacement !== 'none';
              return (
                <button
                  key={road.id}
                  type="button"
                  className={`cfv2-road-piece road-${road.kind} ${selected ? 'is-selected' : ''} ${!road.visible && !premiumVisual ? 'is-hidden-ghost' : ''} ${roadReplaced ? 'is-replaced' : ''}`}
                  style={{
                    left: road.x,
                    top: road.y,
                    width: ROAD_TILE_SIZE,
                    height: ROAD_TILE_SIZE,
                    transform: `rotate(${road.rotation}deg)`,
                    zIndex: 50,
                  }}
                  onPointerDown={(event) => {
                    if (layoutEditMode) { setSelectedRoadId(road.id); setSelectedFieldId(null); setPlazaSelected(false); setSelectedCreativeId(null); }
                    startDecorDrag(event, road);
                  }}
                  onPointerMove={(event) => moveDecorDrag(event, road)}
                  onPointerUp={stopDecorDrag}
                  onPointerCancel={stopDecorDrag}
                  onClick={(event) => {
                    if (layoutEditMode) {
                      event.preventDefault();
                      event.stopPropagation();
                      setSelectedRoadId(road.id);
                    }
                  }}
                  aria-label={`${tr.roadEditor} ${road.id}`}
                >
                  {!roadReplaced && (
                    <svg viewBox="0 0 460 460" aria-hidden="true">
                      {paths.map((d, index) => <path key={`walk-${index}`} className="road-sidewalk" d={d} />)}
                      {paths.map((d, index) => <path key={`curb-${index}`} className="road-curb" d={d} />)}
                      {paths.map((d, index) => <path key={`surface-${index}`} className="road-surface" d={d} />)}
                      {paths.map((d, index) => <path key={`lane-${index}`} className="road-lane" d={d} />)}
                    </svg>
                  )}
                  {roadReplaced && <span className="cfv2-road-replacement" style={{ transform: `rotate(${-road.rotation}deg)` }}><CreativeDecorVisual type={road.replacement} /></span>}
                  {!road.visible && layoutEditMode && <span className="cfv2-hidden-road-label" style={{ transform: `translate(-50%, -50%) rotate(${-road.rotation}deg)` }}>👁 {tr.show}</span>}
                  {selected && <span className="cfv2-road-piece-selected">✥</span>}
                </button>
              );
            })}
          </div>

          {placedPlaza.visible && (
          <button
            type="button"
            className={`cfv2-plaza cfv2-plaza-movable plaza-style-${placedPlaza.style} ${plazaSelected ? 'is-selected' : ''} ${!placedPlaza.visible && !premiumVisual ? 'is-hidden-ghost' : ''}`}
            style={{ left: placedPlaza.x, top: placedPlaza.y, width: placedPlaza.width, height: placedPlaza.height, zIndex: 51 }}
            onPointerDown={(event) => {
              if (layoutEditMode) { setPlazaSelected(true); setSelectedRoadId(null); setSelectedFieldId(null); setSelectedCreativeId(null); }
              startDecorDrag(event, placedPlaza);
            }}
            onPointerMove={(event) => moveDecorDrag(event, placedPlaza)}
            onPointerUp={stopDecorDrag}
            onPointerCancel={stopDecorDrag}
            onClick={(event) => {
              if (layoutEditMode) {
                event.preventDefault();
                event.stopPropagation();
                setPlazaSelected(true);
              }
            }}
            aria-label={language === 'en' ? 'Central plaza' : 'Plaza central'}
          >
            <span className="cfv2-plaza-pattern" aria-hidden="true" />
            {placedPlaza.accessories.includes('fountain') && <span className="cfv2-plaza-accessory plaza-fountain"><CreativeDecorVisual type="fountain" /></span>}
            {placedPlaza.accessories.includes('tree') && <span className="cfv2-plaza-accessory plaza-tree"><CreativeDecorVisual type="tree" /></span>}
            {placedPlaza.accessories.includes('flowers') && <span className="cfv2-plaza-accessory plaza-flowers"><CreativeDecorVisual type="garden" /></span>}
            {placedPlaza.accessories.includes('bench') && <span className="cfv2-plaza-accessory plaza-bench"><CreativeDecorVisual type="bench" /></span>}
            {placedPlaza.accessories.includes('lamps') && <><span className="cfv2-plaza-accessory plaza-lamp-a"><CreativeDecorVisual type="lamp" /></span><span className="cfv2-plaza-accessory plaza-lamp-b"><CreativeDecorVisual type="lamp" /></span></>}
            {placedPlaza.accessories.includes('sign') && <span className="cfv2-plaza-accessory plaza-sign"><CreativeDecorVisual type="sign" /></span>}
            {!placedPlaza.visible && layoutEditMode && <span className="cfv2-hidden-plaza-label">👁 {tr.show}</span>}
          </button>
          )}

          <div className="cfv2-creative-decor-layer" aria-label={tr.creativeTitle}>
            {placedCreativeDecor.map((decor) => {
              if (!decor.visible) return null;
              const selected = layoutEditMode && selectedCreativeId === decor.id;
              return (
                <button
                  key={decor.id}
                  type="button"
                  className={`cfv2-creative-decor ${decor.type.startsWith('ground-') ? 'cfv2-ground-tile' : ''} ${decor.type.startsWith('fence-') ? 'cfv2-fence-piece' : ''} ${selected ? 'is-selected' : ''} ${!decor.visible ? 'is-hidden-ghost' : ''}`}
                  style={{ ...getArrangeFrameStyle(decor.width, decor.height), left: decor.x, top: decor.y, width: decor.width, height: decor.height, transform: `rotate(${decor.rotation}deg)`, zIndex: decor.type.startsWith('ground-') ? 40 : 180 + decor.y }}
                  onPointerDown={(event) => {
                    if (layoutEditMode) { setSelectedCreativeId(decor.id); setSelectedRoadId(null); setSelectedFieldId(null); setPlazaSelected(false); }
                    startDecorDrag(event, decor);
                  }}
                  onPointerMove={(event) => moveDecorDrag(event, decor)}
                  onPointerUp={stopDecorDrag}
                  onPointerCancel={stopDecorDrag}
                  onClick={(event) => { if (layoutEditMode) { event.preventDefault(); event.stopPropagation(); setSelectedCreativeId(decor.id); } }}
                  aria-label={language === 'en' ? CREATIVE_DECOR_LABELS[decor.type].en : CREATIVE_DECOR_LABELS[decor.type].es}
                >
                  <CreativeDecorVisual type={getFloorBase(decor.type)} />
                  {selected && <span className="cfv2-creative-selected">✥</span>}
                  {!decor.visible && layoutEditMode && <small>👁 {tr.show}</small>}
                </button>
              );
            })}
          </div>

          <div className="cfv2-puddle-layer" aria-hidden="true">
            {SHIFTED_PUDDLES.map(([x, y, width, height], index) => (
              <span
                key={`puddle-${index}`}
                className="cfv2-puddle"
                style={{
                  left: x,
                  top: y,
                  width,
                  height,
                  opacity: clamp(groundWetness * 1.18 - (index % 4) * 0.07, 0, 1),
                }}
              />
            ))}
          </div>

          {groundWetness > 0.22 && effectiveWeather !== 'rain' && effectiveWeather !== 'storm' && (
            <div className="cfv2-postweather-debris" aria-hidden="true">
              {POST_WEATHER_DEBRIS.map(([x, y, rotate], index) => (
                <span
                  key={`post-weather-${index}`}
                  className={index % 3 === 0 ? 'twig' : 'leaf'}
                  style={{ left: x, top: y, transform: `rotate(${rotate}deg)`, opacity: clamp(groundWetness * 1.25, .18, .9) }}
                />
              ))}
            </div>
          )}

          <div className="cfv2-footprint-layer" aria-hidden="true">
            {footprints.map((print, index) => (
              <span
                key={print.id}
                className={`cfv2-footprint facing-${print.facing} ${index % 2 ? 'step-right' : 'step-left'}`}
                style={{ left: print.x, top: print.y }}
              >
                •
              </span>
            ))}
          </div>

          <div className="cfv2-road-traffic" aria-hidden="true">
            {SHIFTED_TRAFFIC.map((vehicle) => (
              <span
                key={vehicle.id}
                className={`cfv2-vehicle vehicle-${vehicle.kind} route-${vehicle.route} ${vehicle.kind === 'truck' && readyProductionCount > 0 ? 'is-collecting' : ''}`}
                style={{
                  left: vehicle.x,
                  top: vehicle.y,
                  '--traffic-duration': `${vehicle.duration}s`,
                  '--traffic-delay': `${vehicle.delay}s`,
                  zIndex: 330 + vehicle.y,
                }}
              >
                <i className="cfv2-vehicle-body" />
                <i className="cfv2-vehicle-cab" />
                <i className="cfv2-vehicle-wheel wheel-a" />
                <i className="cfv2-vehicle-wheel wheel-b" />
                {vehicle.kind === 'tractor' && <i className="cfv2-tractor-pipe" />}
                {vehicle.kind === 'truck' && readyProductionCount > 0 && (
                  <i className="cfv2-service-load" aria-hidden="true">📦</i>
                )}
              </span>
            ))}
          </div>

          <div className="cfv2-world-npcs" aria-hidden="true">
            {SHIFTED_NPCS.map((npc) => (
              <span
                key={npc.id}
                className={`cfv2-world-npc route-${npc.route}`}
                style={{
                  left: npc.x,
                  top: npc.y,
                  '--npc-duration': `${npc.duration}s`,
                  '--npc-delay': `${npc.delay}s`,
                  zIndex: 340 + npc.y,
                }}
              >
                <span>{npc.icon}</span>
              </span>
            ))}
          </div>


          <button
            type="button"
            className="cfv2-decor-item cfv2-decor-lake"
            style={{
              left: placedLake.x,
              top: placedLake.y,
              width: placedLake.width,
              height: placedLake.height,
              zIndex: 190 + placedLake.y,
            }}
            onPointerDown={(event) => startDecorDrag(event, placedLake)}
            onPointerMove={(event) => moveDecorDrag(event, placedLake)}
            onPointerUp={stopDecorDrag}
            onPointerCancel={stopDecorDrag}
            onClick={(event) => {
              if (layoutEditMode) {
                event.preventDefault();
                event.stopPropagation();
              }
            }}
            aria-label={language === 'en' ? 'Lake' : 'Lago'}
          >
            <span className="cfv2-lake-shadow" aria-hidden="true" />
            <span className="cfv2-lake-body" aria-hidden="true">
              <i className="cfv2-lake-water water-a" />
              <i className="cfv2-lake-water water-b" />
              <i className="cfv2-lake-shine" />
              <i className="cfv2-lake-lily lily-a">✿</i>
              <i className="cfv2-lake-lily lily-b">✿</i>
              <i className="cfv2-lake-rock rock-a" />
              <i className="cfv2-lake-rock rock-b" />
              <i className="cfv2-lake-reed reed-a" />
              <i className="cfv2-lake-reed reed-b" />
            </span>
          </button>

          {placedLamps.map((lamp, index) => (
            <button
              key={lamp.id}
              type="button"
              className="cfv2-decor-item cfv2-decor-lamp"
              style={{ ...getArrangeFrameStyle(lamp.width, lamp.height), left: lamp.x, top: lamp.y, width: lamp.width, height: lamp.height, zIndex: 180 + lamp.y }}
              onPointerDown={(event) => startDecorDrag(event, lamp)}
              onPointerMove={(event) => moveDecorDrag(event, lamp)}
              onPointerUp={stopDecorDrag}
              onPointerCancel={stopDecorDrag}
              onClick={(event) => {
                if (layoutEditMode) {
                  event.preventDefault();
                  event.stopPropagation();
                }
              }}
              aria-label="Lamp"
            >
              <span className="cfv2-lamp" aria-hidden="true" />
            </button>
          ))}

          {placedTrees.filter((tree) => tree.visible).map((tree, index) => (
            <button
              key={tree.id}
              type="button"
              className="cfv2-decor-item cfv2-decor-tree"
              style={{ ...getArrangeFrameStyle(tree.width, tree.height), left: tree.x, top: tree.y, width: tree.width, height: tree.height, zIndex: 100 + tree.y }}
              onPointerDown={(event) => { if (layoutEditMode) setSelectedTreeId(tree.id); startDecorDrag(event, tree); }}
              onPointerMove={(event) => moveDecorDrag(event, tree)}
              onPointerUp={stopDecorDrag}
              onPointerCancel={stopDecorDrag}
              onClick={(event) => {
                if (layoutEditMode) {
                  event.preventDefault();
                  event.stopPropagation();
                }
              }}
              aria-label="Tree"
            >
              <img
                className="cfv2-tree"
                src={arbol}
                alt=""
                draggable="false"
                style={{
                  left: 0,
                  top: 0,
                  zIndex: 100 + tree.y,
                  '--cfv2-sway-delay': `${-(index % 7) * 0.37}s`,
                }}
              />
            </button>
          ))}

          {SHIFTED_ANIMALS.map((animal) => {
            const animalTelemetry = animal.type === 'cow' ? cowTelemetry : chickenTelemetry;
            const resting = restPhase && animalTelemetry.status !== 'ready';
            const ready = animalTelemetry.status === 'ready';
            const producing = animalTelemetry.status === 'working';

            return (
              <span
                key={animal.id}
                className={`cfv2-animal cfv2-animal-${animal.type} route-${animal.route} ${resting ? 'is-resting' : ''} ${ready ? 'production-ready' : ''} ${producing ? 'production-active' : ''}`}
                style={{
                  left: animal.x,
                  top: animal.y,
                  width: Math.round(animal.size * (animal.type === 'cow' ? 1.45 : 1.35)),
                  zIndex: 420 + animal.y,
                  '--cfv2-animal-duration': `${animal.duration * animalWeatherFactor * (resting ? 2.6 : 1)}s`,
                  '--cfv2-animal-delay': `${animal.delay}s`,
                }}
                aria-hidden="true"
              >
                <img className="cfv2-animal-sprite" src={animal.image} alt="" draggable="false" />
                <span className="cfv2-animal-shadow" />
                <span className="cfv2-animal-production-bubble">
                  {ready
                    ? (animal.type === 'cow' ? '🥛' : '🥚')
                    : resting
                      ? 'Zzz'
                      : producing
                        ? '•'
                        : ''}
                </span>
                <span className="cfv2-animal-weather-reaction">
                  {effectiveWeather === 'storm' ? '⚡' : effectiveWeather === 'rain' ? '💧' : ''}
                </span>
              </span>
            );
          })}

          <div className="cfv2-world-wind" aria-hidden="true">
            <span /><span /><span /><span /><span />
          </div>

          <div className="cfv2-world-clouds" aria-hidden="true">
            {SHIFTED_CLOUDS.map((cloud) => (
              <span
                key={cloud.id}
                className="cfv2-world-cloud"
                style={{
                  left: cloud.x,
                  top: cloud.y,
                  width: cloud.width,
                  height: Math.round(cloud.width * 0.42),
                  opacity: cloud.opacity,
                  '--cloud-duration': `${cloud.duration}s`,
                  '--cloud-delay': `${cloud.delay}s`,
                }}
              >
                <i className="puff puff-a" />
                <i className="puff puff-b" />
                <i className="puff puff-c" />
              </span>
            ))}
          </div>

          <div className="cfv2-tumbleweed-field" aria-hidden="true">
            <span className="tumble t1">✺</span>
            <span className="tumble t2">✺</span>
            <span className="tumble t3">✺</span>
            <span className="tumble t4">✺</span>
          </div>

          <div className="cfv2-dust-devils" aria-hidden="true">
            <span className="dust d1"><i /><i /><i /></span>
            <span className="dust d2"><i /><i /><i /></span>
            <span className="dust d3"><i /><i /><i /></span>
          </div>

          <div className="cfv2-leaf-field" aria-hidden="true">
            {Array.from({ length: 12 }).map((_, index) => (
              <span key={`leaf-${index}`} style={{ '--leaf-i': index }}>🍂</span>
            ))}
          </div>

          <div className="cfv2-butterfly-field" aria-hidden="true">
            {Array.from({ length: 8 }).map((_, index) => (
              <span key={`butterfly-${index}`} style={{ '--butterfly-i': index }}>🦋</span>
            ))}
          </div>

          {placedBuildings.map((building) => {
            const near = nearestBuilding?.building.id === building.id;
            const landState = building.stateKey ? informacion?.tierras?.[building.stateKey] : null;
            const lockedLand = Boolean(building.stateKey && !landState?.habilitado);
            const buildingLevel = Math.max(1, Math.floor(getBuildingLevel(informacion, building)));
            const extraCopies = 0;
            const displayImage = getDisplayImageForLevel(building, buildingLevel);
            const cropVisualState = isCropBuilding(building)
              ? getCropVisualState(landState)
              : null;
            const productionTelemetry = getBuildingTelemetry(building, landState);
            const productionReady = productionTelemetry?.status === 'ready';
            const productionActive = productionTelemetry?.status === 'working';
            const productionIdle = productionTelemetry?.status === 'idle';
            const productionStage = productionTelemetry?.stage || 0;
            const productionProgress = Math.round((productionTelemetry?.progress || 0) * 100);
            return (
              <button
                key={building.id}
                type="button"
                className={`cfv2-building ${near ? 'is-near' : ''} ${lockedLand ? 'is-locked-land' : ''} ${building.levelCopies ? 'has-level-copies' : ''} ${cropVisualState ? `crop-${cropVisualState}` : ''} ${productionReady ? 'production-ready' : ''} ${productionActive ? 'production-active' : ''} ${productionIdle ? 'production-idle' : ''} production-stage-${productionStage} ${building.id === 'mill' && millActive ? 'mill-active-real' : ''}`}
                data-building={building.id}
                style={{
                  ...getArrangeFrameStyle(
                    building.width,
                    Math.max(120, Math.min(200, Math.round(building.width * 0.72))),
                  ),
                  left: building.x,
                  top: building.y,
                  width: building.width,
                  zIndex: 500 + building.collider.y + building.collider.h,
                }}
                onPointerDown={(event) => startBuildingDrag(event, building)}
                onPointerMove={(event) => moveBuildingDrag(event, building)}
                onPointerUp={stopBuildingDrag}
                onPointerCancel={stopBuildingDrag}
                onClick={(event) => {
                  if (layoutEditMode) {
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                  }
                  inspectBuilding(building);
                }}
                aria-label={BUILDING_NAMES[language]?.[building.id] || building.name}
              >
                {Array.from({ length: extraCopies }).map((_, copyIndex) => (
                  <img
                    key={`${building.id}-level-copy-${copyIndex + 2}`}
                    className={`cfv2-building-level-copy copy-${copyIndex + 2}`}
                    src={displayImage}
                    alt=""
                    draggable="false"
                    aria-hidden="true"
                  />
                ))}
                {!RURAL_FACILITY_SPRITES[building.id] && (building.facility ||
                  building.promo === 'bigdogbone' ||
                  ['home', 'cows', 'chickens'].includes(building.id)) && (
                  <span
                    className={`cfv2-building-garden garden-${building.facilityKind || building.id}`}
                    aria-hidden="true"
                  />
                )}
                {RURAL_FACILITY_SPRITES[building.id] ? (
                  <img
                    className="cfv2-rural-building-sprite"
                    src={RURAL_FACILITY_SPRITES[building.id]}
                    alt=""
                    aria-hidden="true"
                    draggable="false"
                  />
                ) : building.promo === 'bigdogbone' ? (
                  <BigDogBoneHouseVisual />
                ) : building.facility ? (
                  <FacilityBuildingVisual kind={building.facilityKind} icon={building.icon} />
                ) : (
                  <img
                    className="cfv2-building-img"
                    src={displayImage}
                    alt=""
                    draggable="false"
                    onError={(event) => {
                      if (event.currentTarget.src !== building.image) {
                        event.currentTarget.src = building.image;
                      }
                    }}
                  />
                )}
                {cropVisualState && cropVisualState !== 'locked' && (
                  <span
                    className={`cfv2-crop-visual state-${cropVisualState} stage-${productionStage}`}
                    style={{ '--production-progress': `${productionProgress}%` }}
                    aria-hidden="true"
                  >
                    <i>{cropIconFor(building, cropVisualState)}</i>
                    {cropVisualState === 'growing' && <><b /><b /><b /></>}
                    {cropVisualState === 'ready' && <em>✦</em>}
                  </span>
                )}
                {building.stateKey && (
                  <span className={`cfv2-world-land-label ${lockedLand ? 'is-locked' : ''}`} aria-hidden="true">
                    <b>{BUILDING_NAMES[language]?.[building.id] || building.name}</b>
                    <small>{lockedLand ? `🔒 ${tr.lockedLand}` : `LV ${buildingLevel}`}</small>
                  </span>
                )}
                {(building.facility || building.promo === 'bigdogbone') && !RURAL_FACILITY_SPRITES[building.id] && (
                  <span className="cfv2-facility-label" aria-hidden="true">
                    <b>{BUILDING_NAMES[language]?.[building.id] || building.name}</b>
                    <small>{tr.interact}</small>
                  </span>
                )}
                {productionTelemetry && productionTelemetry.status !== 'locked' && (
                  <span
                    className={`cfv2-production-beacon status-${productionTelemetry.status}`}
                    style={{ '--production-progress': `${productionProgress}%` }}
                    aria-hidden="true"
                  >
                    <i />
                    <b>
                      {productionReady
                        ? '!'
                        : productionActive
                          ? `${Math.max(1, productionProgress)}%`
                          : '•'}
                    </b>
                  </span>
                )}
                {building.id === 'energy' && (
                  <>
                    <span className={`cfv2-energy-spark ${energyTelemetry.status === 'ready' ? 'is-ready' : energyTelemetry.status === 'working' ? 'is-working' : 'is-idle'}`} aria-hidden="true">⚡</span>
                    <span className="cfv2-smoke cfv2-smoke-a" aria-hidden="true" />
                    <span className="cfv2-smoke cfv2-smoke-b" aria-hidden="true" />
                  </>
                )}
                {building.id === 'water' && (
                  <span className={`cfv2-water-pulse ${waterTelemetry.status === 'ready' ? 'is-ready' : waterTelemetry.status === 'working' ? 'is-working' : 'is-idle'}`} aria-hidden="true">
                    {waterTelemetry.status === 'ready' && <i>💧</i>}
                  </span>
                )}
                {building.id === 'mill' && (
                  <span className={`cfv2-mill-motion ${millActive ? 'is-working' : 'is-standby'}`} aria-hidden="true">
                    {millActive ? '⚙' : '✦'}
                  </span>
                )}
                {near && <span className="cfv2-near-tag">{building.icon} {tr.interact}</span>}
              </button>
            );
          })}

          {walkTarget && (
            <span
              className="cfv2-walk-target"
              aria-hidden="true"
              style={{ left: walkTarget.x, top: walkTarget.y, zIndex: 850 + Math.floor(walkTarget.y) }}
            />
          )}

          <div
            className={`cfv2-player ${isMoving ? 'is-walking' : ''} facing-${facing}`}
            style={{ left: player.x, top: player.y, zIndex: 1000 + Math.floor(player.y) }}
            aria-label="Jugador"
          >
            <div className="cfv2-player-shadow" />
            <div className="cfv2-player-body">
              <img src={PLAYER_SPRITE} alt="Jugador" draggable="false" />
            </div>
            <span className="cfv2-player-name">{playerName}</span>
          </div>
        </div>

        <div
          className="cfv2-ambient-overlay cfv2-sunset-overlay"
          style={{ opacity: dayCycle.warmOpacity }}
          aria-hidden="true"
        />
        <div
          className="cfv2-ambient-overlay cfv2-night-overlay"
          style={{ opacity: dayCycle.nightOpacity }}
          aria-hidden="true"
        />
        <div
          className="cfv2-light-layer"
          style={{
            width: WORLD.width,
            height: WORLD.height,
            transform: `translate3d(${camera.x + 18 * zoom}px, ${camera.y + 18 * zoom}px, 0) scale(${zoom})`,
          }}
          aria-hidden="true"
        >
          {placedLamps.map((lamp, index) => (
            <span
              key={`glow-${lamp.id}-${index}`}
              className="cfv2-lamp-glow"
              style={{ left: lamp.x, top: lamp.y, opacity: dayCycle.lampOpacity }}
            />
          ))}
          {SHIFTED_FIREFLIES.map(([x, y], index) => (
            <span
              key={`firefly-${x}-${y}-${index}`}
              className="cfv2-firefly"
              style={{
                left: x,
                top: y,
                opacity: dayCycle.fireflyOpacity,
                '--cfv2-firefly-delay': `${-(index % 6) * 0.63}s`,
              }}
            />
          ))}
        </div>


        <div className={`cfv2-weather-screen weather-${effectiveWeather}`} aria-hidden="true">
          <div className="cfv2-cloud-shadow-sheet" />
          <div className="cfv2-rain-sheet rain-back" />
          <div className="cfv2-rain-sheet rain-front" />
          <div className="cfv2-rain-splashes">
            {Array.from({ length: 14 }).map((_, index) => (
              <span key={`splash-${index}`} style={{ '--splash-i': index }} />
            ))}
          </div>
          <div className="cfv2-lightning-flash" />
          <div className="cfv2-weather-vignette" />
        </div>

        <div
          className="cfv2-joystick-pad"
          role="group"
          aria-label="Joystick de movimiento"
          onPointerDown={startJoystick}
          onPointerMove={(event) => {
            if (event.currentTarget.hasPointerCapture?.(event.pointerId)) onJoystickPointer(event);
          }}
          onPointerUp={stopJoystick}
          onPointerCancel={stopJoystick}
        >
          <span className="cfv2-joystick-ring" />
          <span
            className="cfv2-joystick-knob"
            style={{ transform: `translate(${joystick.x * 38}px, ${joystick.y * 38}px)` }}
          />
        </div>


        {selectedBuilding && (
          <div className="cfv2-panel-backdrop" onMouseDown={(event) => {
            if (event.target === event.currentTarget) setSelectedBuildingId(null);
          }}>
            <section className="cfv2-building-panel" aria-label={`Información de ${selectedBuilding.name}`}>
              <button
                type="button"
                className="cfv2-panel-close"
                onClick={() => setSelectedBuildingId(null)}
                aria-label="Cerrar"
              >
                ×
              </button>
              <div className="cfv2-panel-icon">{selectedBuilding.icon}</div>
              <div className="cfv2-panel-copy">
                <span className="cfv2-panel-kicker">{tr.nearby}</span>
                <h2>{BUILDING_NAMES[language]?.[selectedBuilding.id] || selectedBuilding.name}</h2>
                <div className="cfv2-panel-stats">
                  <span>{tr.level} <strong>{formatNumber(getBuildingLevel(informacion, selectedBuilding))}</strong></span>
                  <span>{tr.distance} <strong>{Math.round(distanceToRect(player.x, player.y, selectedBuilding.collider))} px</strong></span>
                </div>
                <p>{tr.realInfo}</p>
                <button
                  type="button"
                  className="cfv2-panel-primary"
                  onClick={() => openRealBuilding(selectedBuilding)}
                >
                  ✓ {tr.openReal}
                </button>
              </div>
            </section>
          </div>
        )}
      </div>

      <Modal
        open={Boolean(activePanel)}
        onClose={closeRealPanel}
        className="rpgui-content cfv2-real-modal"
        aria-label="CITYFARM V2 real feature"
      >
        <Box className="rpgui-container framed cfv2-real-panel" sx={REAL_MODAL_STYLE}>
          {activePanel?.type === 'water' && <Agua handleClose={closeRealPanel} selector={activeSelector} />}
          {activePanel?.type === 'corn' && <TierraMaiz handleClose={closeRealPanel} selector={activeSelector} />}
          {activePanel?.type === 'wheat' && <Trigo handleClose={closeRealPanel} selector={activeSelector} />}
          {activePanel?.type === 'tree' && <Arbol handleClose={closeRealPanel} selector={activeSelector} />}
          {activePanel?.type === 'energy' && <Energia handleClose={closeRealPanel} selector={activeSelector} />}
          {activePanel?.type === 'cows' && <Vaca handleClose={closeRealPanel} selector={activeSelector} />}
          {activePanel?.type === 'chickens' && <Gallinero handleClose={closeRealPanel} selector={activeSelector} />}
          {activePanel?.type === 'mill' && <Molino handleClose4={closeRealPanel} />}
          {activePanel?.type === 'lands' && (
            <div className="cfv2-land-office-panel">
              <div className="cfv2-land-office-head">
                <div><span>🌱</span><div><small>CITYFARM</small><h2>{tr.landsTitle}</h2></div></div>
                <button type="button" onClick={closeRealPanel}>✕</button>
              </div>
              <p>{language === 'en' ? 'All real lands remain connected to the existing CITYFARM modules.' : 'Todas las tierras reales siguen conectadas a los módulos existentes de CITYFARM.'}</p>
              <div className="cfv2-land-office-grid">
                {REAL_LAND_SHORTCUTS.map((item) => {
                  const land = item.selectorKey ? informacion?.tierras?.[item.selectorKey] : null;
                  const statusKey = item.type === 'mill' ? 'idle' : getLandStatusKey(land);
                  const locked = statusKey === 'lockedShort';
                  return (
                    <button
                      type="button"
                      key={item.id}
                      className={locked ? 'is-locked' : ''}
                      onClick={() => openShortcut(item)}
                    >
                      <span>{item.icon}</span>
                      <b>{language === 'en' ? item.en : item.es}</b>
                      <small>{tr[statusKey]}</small>
                    </button>
                  );
                })}
              </div>
            </div>
          )}
          {activePanel?.type === 'inventory' && <Wallet handleClose={closeRealPanel} />}
          {activePanel?.type === 'objects' && <Objetos handleClose={closeRealPanel} />}
          {activePanel?.type === 'trade' && <TradesMarket handleClose4={closeRealPanel} />}
          {activePanel?.type === 'packs' && <PacksMarket handleClose4={closeRealPanel} />}
          {activePanel?.type === 'profile' && <Profile handleClose={closeRealPanel} />}
          {activePanel?.type === 'pool' && <Stake />}
        </Box>
      </Modal>

      {/* Mismos módulos reales que usa la versión clásica. */}
      <CityFarmVisitFarms npcMode={false} showAccessButton={false} />
      <PetOverlay />
    </div>
  );
}

